import termsAndConditionsTemplateTh from '@/i18n/termsAndConditions/th'
import acknowledgeTemplateTh from '@/i18n/acknowledgeRisk/th'

export default {
  messages: {
    per_total_income: 'ต่อเงินได้ทั้งหมด',
    please_specify: 'โปรดระบุ',
    loading: 'กำลังโหลด',
    close: 'ปิด',
    back: 'กลับ',
    receive: 'ได้รับ',
    for_receive: 'เพื่อรับ',
    copied: 'คัดลอกแล้ว !',
    can_not_copy: `ไม่สามารถคัดลอกได้ กรุณาลองอีกครั้ง`,
    no_result_found: 'ไม่พบข้อมูล',
    img_size_must_less_than: 'ขนาดรูปภาพต้องน้อยกว่า {0} MB',
    uploading_your: 'กำลังอัปโหลด',
    submitting_your_info: 'กำลังอัปโหลดข้อมูลของคุณ',
    click_to_see_doc: 'กดเพื่อดูเอกสาร',
    congratulations: 'ยินดีด้วย',
    you_have_got_kul: `คุณได้รับเหรียญ {0} KUL`,
    thanks_for_connect_social_with_us: 'ขอบคุณที่เชื่อมต่อ {0} กับเรา',
    thanks_for_subscribe: 'ขอบคุณที่สมัครสมาชิกจดหมายข่าวกับเรา',
    thanks_for_registration: 'ขอบคุณที่สมัครสมาชิกกับเรา',
    thanks_for_submited: 'ขอบคุณสำหรับข้อมูลการยืนยันตัวตน',
    google: 'กูเกิล',
    facebook: 'เฟซบุ๊ก',
    not_support: 'ไม่รองรับ',
    wrong_eth_network: '<span>กรุณาเปลี่ยนเน็ตเวิร์คไปยัง <b>{0} Ethereum Network</b>.</span>',
    please_fill_info: 'กรุณากรอกข้อมูล',
    hi: 'สวัสดี',
    please_confirm_email_after_regis: 'กรุณายืนยันอีเมลหลังจากลงทะเบียนเสร็จสิ้น',
    resend_an_email: 'ส่งอีเมลยืนยันอีกครั้ง',
    metamask_connected: 'เชื่อมต่อ Metamask แล้ว !',
    wallet_connect_connected: 'เชื่อมต่อ Wallet Connect แล้ว !',
    login_error: 'ไม่สามารถเข้าสู่ระบบ',
    not_login_metamask: 'คุณอาจจะยังไม่ได้เข้าสู่ระบบ <b>MetaMask</b>, กรุณาเข้าสู่ระบบแล้วลองใหม่อีกครั้ง.'
  },
  errors: {
    default: 'เกิดข้อผิดพลาด',
    balance_not_enough: 'จำนวนเหรียญของคุณไม่เพียงพอ',
    eth_not_enough_for_network_fee: 'จำนวนเหรียญ ETH ของคุณไม่เพียงพอสำหรับค่าธรรมเนียมเครือข่าย'
  },
  buttons: {
    ok: 'OK',
    login: 'เข้าสู่ระบบ',
    logout: 'ออกจากระบบ',
    submit: 'ตกลง',
    next: 'ต่อไป',
    back: 'กลับ',
    verify_again: 'ตรวจสอบอีกครั้ง',
    login_register: 'เข้าสู่ระบบ / สมัครสมาชิก'
  },
  menu: {
    profile: 'ข้อมูลส่วนตัว',
    tradeHistory: 'ประวัติการเทรด',
    kyc: 'ยืนยันตัวตน',
    suit_test: 'แบบประเมินความเสี่ยงด้านการลงทุน',
    knowledge_test: 'แบบทดสอบประเมินความรู้',
    knowledge_test_correct_answer: 'เฉลยคำตอบที่ถูกต้อง',
    referral_program: 'โปรแกรมชวนเพื่อน',
    kulap_token: 'เหรียญ KULAP',
    logout: 'ออกจากระบบ'
  },
  login: {
    remember_me: 'ให้ฉันอยู่ในระบบต่อไป',
    login_uppercase: 'เข้าสู่ระบบ',
    register_now: 'สมัครสมาชิก'
  },
  register: {
    register: 'สมัครสมาชิก',
    register_uppercase: 'สมัครสมาชิก',
    login_with: 'เข้าสู่ระบบด้วย {0}',
    or: 'หรือ',
    and: 'และ',
    email: 'อีเมล',
    email_placeholder: 'กรุณากรอกอีเมล',
    password: 'รหัสผ่าน',
    password_condition: '(*อย่างน้อย 8 ตัวอักษรที่ประกอบไปด้วย ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และ ตัวเลข)',
    password_placeholder: 'กรุณากรอกรหัสผ่าน',
    password_meter_0: 'อ่อนแอมาก',
    password_meter_1: 'อ่อนแอ',
    password_meter_2: 'ปกติ',
    password_meter_3: 'ปลอดภัย',
    password_meter_4: 'ปลอดภัยสูง',
    confirm_password: 'ยืนยันรหัสผ่าน',
    confirm_password_placeholder: 'กรุณายืนยันรหัสผ่าน',
    subscribe: 'สมัครสมาชิกจดหมายข่าว',
    agree_to: 'ยอมรับ',
    terms_conditions: 'ข้อกำหนดและเงื่อนไข',
    infor_before_regis: 'เงื่อนไขการใช้บริการ',
    privacy_policy: 'นโยบายข้อมูลส่วนบุคคล',
    aml_policy: 'นโยบายป้องกันปราบปรามการฟอกเงิน',
    if_you_have_question: 'ถ้าคุณมีคำถามหรือพบปัญหาใด ๆ',
    please_contact: 'กรุณาติดต่อมาที่อีเมล support@kulap.io (ทุกวันตลอด 24 ชั่วโมง).',
    license_by: 'ได้รับใบอนุญาตจาก'
  },
  register_status: {
    title: 'สมัครสมาชิกสำเร็จ',
    you_have_got_email: 'คุณได้รับอีเมลแล้ว',
    please_confirm_email: 'กรุณาตรวจสอบอีเมลและกดยืนยันการสมัครสมาชิกเพื่อเปิดใช้งานบัญชีของคุณ',
    if_not_receive_email_facebook: `หากคุณไม่ได้รับอีเมล กรุณาตรวจสอบในจดหมายขยะก่อนหรือกดออกจากระบบและเข้าสู่ระบบใหม่อีกครั้ง`,
    if_not_receive_email: `หากคุณไม่ได้รับอีเมล กรุณากดลิงก์ด้านล่างเพื่อส่งอีเมลใหม่อีกครั้ง`,
    resend_email: 'ส่งอีเมลใหม่อีกครั้ง'
  },
  confirm_email: {
    verifying: 'รอการตรวจสอบ',
    activated: 'เสร็จสมบูรณ์',
    welcome: 'ยินดีต้อนรับเข้าสู่ KULAP',
    activate_detail: 'คุณได้เปิดบัญชีอย่างเสร็จสมบูรณ์แล้ว คลิ๊กลิงก์ด้านล่างเพื่อเพลิดเพลินกับการแลกเปลี่ยน',
    go_to_exchange: 'กลับสู่หน้าหลัก',
    error: 'ผิดพลาด',
    error_title: 'มีบางอย่างผิดพลาด',
    error_detail: 'กรุณากดปุ่ม <b>ส่งอีเมลอีกครั้ง</b> เพื่อส่งอีเมลยืนยีนตัวตนอีกครั้ง หรือกดปุ่ม <b>กลับสู่หน้าหลัก</b> เพื่อไปสู่หน้าหลัก',
    resend_email: 'ส่งอีเมลอีกครั้ง',
    login_first: 'กรุณาเข้าสู่ระบบ',
    click_btn_below: 'กดปุ่มด้านล่างเพื่อ <b>เข้าสู่ระบบ</b>'
  },
  notification: {
    nothing_here: 'อุ๊ย ... ไม่มีอะไรที่นี่',
    have_no_noti: `ยังไม่มีธุรกรรมเกิดขึ้น`,
    success: 'สำเร็จ',
    failed: 'ไม่สำเร็จ',
    on_process: 'กำลังดำเนินการ',
    received_registration_reward: 'สมัครสมาชิกสำเร็จ',
    received_connect_with_facebook_reward: 'เชื่อมต่อเฟซบุ๊กสำเร็จ',
    received_connect_with_google_reward: 'เชื่อมต่อกูเกิลสำเร็จ',
    received_subscribe_news_letter_reward: 'ติดตามข่าวสารเรียบร้อยแล้ว',
    received_kycapproved_reward: 'การยืนยันตัวตนของคุณได้รับการอนุมัติแล้ว',
    get_connect_with_facebook_reward: 'รับเหรียญฟรี 50 KUL',
    get_connect_with_google_reward: 'รับเหรียญฟรี 50 KUL',
    get_subscribe_news_letter_reward: 'รับเหรียญฟรี 50 KUL',
    get_k_y_c_approved_reward: 'รับเหรียญฟรี 500 KUL',
    received_referral_program_reward: 'คุณได้รับรางวัลจากโปรแกรมชวนเพื่อน',
    get_referral_program_reward: 'ชวนเพื่อนของคุณเพื่อรับรางวัล',
    take_the_suitability_test: 'กรุณาทำแบบประเมินความเสี่ยงด้านการลงทุน',
    take_the_knowledge_test: 'กรุณาทำแบบทดสอบประเมินความรู้',
    sub_received_registration_reward: 'ได้รับเหรียญ 50 KUL',
    sub_received_connect_with_facebook_reward: 'ได้รับเหรียญ 50 KUL',
    sub_received_connect_with_google_reward: 'ได้รับเหรียญ 50 KUL',
    sub_received_subscribe_news_letter_reward: 'ได้รับเหรียญ 50 KUL',
    sub_received_kycapproved_reward: 'ได้รับเหรียญ 500 KUL',
    sub_get_connect_with_facebook_reward: 'เชื่อมต่อเฟซบุ๊กของคุณเพื่อรับรางวัล',
    sub_get_connect_with_google_reward: 'เชื่อมต่อกูเกิลของคุณเพื่อรับรางวัล',
    sub_get_subscribe_news_letter_reward: 'กดติดตามข่าวสารจาก KULAP เพื่อรับรางวัล',
    sub_get_k_y_c_approved_reward: 'ยืนยันตัวตนให้เสร็จสมบูรณ์',
    sub_received_referral_program_reward: 'กดเพื่อดูเพิ่มเติม...',
    sub_get_referral_program_reward: 'กดเพื่อดูเพิ่มเติม...',
    sub_take_the_suitability_test: 'จะสามารถแลกเปลี่ยนได้หลังจากทำแบบทดสอบแล้ว',
    sub_take_the_knowledge_test: 'จะสามารถแลกเปลี่ยนได้หลังจากทำแบบทดสอบแล้ว'
  },
  profile: {
    profile: 'ข้อมูลส่วนตัว',
    display_name: 'ชื่อที่แสดง',
    email_address: 'อีเมล',
    kul_balance: 'จำนวนเหรียญ KULAP',
    connect_with_facebook: 'เชื่อมต่อเฟซบุ๊ก',
    connect_facebook_acc: 'เชื่อมต่อระบบด้วยบัญชีเฟซบุ๊ก',
    connect_with_google: 'เชื่อมต่อกูเกิล',
    connect_google_acc: 'เชื่อมต่อระบบด้วยบัญชีกูเกิล',
    kyc_detail: 'ผู้ใช้งานกรอกเอกสารการยืนยันตัวตน และอัปโหลดเอกสารเพิ่มเติม',
    exchange_condition: 'จะสามารถแลกเปลี่ยนได้หลังจากยืนยันตัวตนเสร็จสิ้น',
    suitability_test_condition: 'จะสามารถแลกเปลี่ยนได้หลังจากทำแบบทดสอบแล้ว',
    knowledge_test_condition: 'จะสามารถแลกเปลี่ยนได้หลังจากทำแบบทดสอบแล้ว',
    unverified: 'ยืนยันตัวตน',
    verifying: 'รอการตรวจสอบ',
    request_change: 'ข้อมูลไม่ถูกต้อง',
    approved: 'อนุมัติ',
    rejected: 'ปฏิเสธการยืนยันตัวตน',
    suit_test_detail: 'แบบสอบถามเพื่อประเมินความเหมาะสมในการลงทุนของลูกค้า',
    take_a_test: 'ทำแบบประเมิน',
    knowledge_test_detail: 'แบบสอบถามเพื่อประเมินความรู้ในการลงทุนของลูกค้า',
    subscribe: 'สมัครสมาชิกจดหมายข่าว',
    subscribe_detail: 'สมัครสมาชิกเพื่อรับข้อมูลล่าสุดจาก KULAP',
    two_fact: 'การยืนยันแบบสองขั้นตอน',
    two_fact_detail: 'เพิ่มความปลอดภัยให้กับบัญชีของคุณด้วยการยืนยันแบบสองขั้นตอน'
  },
  kyc: {
    nationality: 'สัญชาติ',
    information: 'ข้อมูลทั่วไป',
    address: 'ที่อยู่',
    identification: 'การยืนยันตัวตน',
    summary: 'สรุป',
    customer_nationality: 'สัญชาติลูกค้า',
    maintenance_header: 'ระบบ KYC กำลังอยู่ในระหว่างการปรับปรุง',
    maintenance_info: 'อยู่ระหว่างการแก้ไขระบบ KYC โปรดเข้ามาอีกครั้งภายหลัง',
    verify_kulap_plus_title: 'ยืนยันตัวตนของคุณบน Kulap Plus',
    verify_kulap_plus_detail: 'สำหรับผู้ใช้ใหม่ กรุณายืนยันตัวตนของคุณบนแพลตฟอร์ม Kulap Plus โดยใช้ที่อยู่อีเมลเดียวกัน กระบวนการนี้จะช่วยให้บัญชีของคุณปลอดภัยและพร้อมใช้งาน',
    verify_kulap_plus_link_text: 'เริ่มการยืนยันตัวตน',
    customer_type: 'ประเภทลูกค้า',
    select_customer_type: 'เลือกประเภทลูกค้า',
    personal: 'บุคคลธรรมดา',
    organization: 'นิติบุคคล',
    customer_information: 'ข้อมูลทั่วไป',
    name_title: 'คำนำหน้า',
    mr: 'นาย',
    miss: 'นางสาว',
    mrs: 'นาง',
    last_name_th: 'นามสกุล (ภาษาไทย)',
    first_name_th: 'ชื่อ (ภาษาไทย)',
    first_name: 'ชื่อ (ภาษาอังกฤษ)',
    middle_name: 'ชื่อกลาง (ภาษาอังกฤษ) (ถ้ามี)',
    middle_name_summary: 'ชื่อกลาง (ภาษาอังกฤษ)',
    last_name: 'นามสกุล (ภาษาอังกฤษ)',
    gender: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    marital_status: 'สถานภาพการสมรส',
    single: 'โสด',
    married: 'สมรส',
    date_of_birth: 'วันเกิด',
    tel_number: 'เบอร์โทรศัพท์',
    click_to_select: 'คลิกเพื่อเลือก ...',
    tel_placeholder: 'ยกตัวอย่าง เช่น 0817766554',
    your_company: 'ชื่อสถานที่ทำงานของคุณ',
    your_company_address: 'ที่อยู่บริษัท',
    your_company_address_line_2: 'ที่อยู่บริษัทบรรทัดที่ 2 (ถ้ามี)',
    your_company_address_line_2_summary: 'ที่อยู่บริษัทบรรทัดที่ 2',
    your_company_country: 'ประเทศที่ตั้งของสถานที่ทำงาน',
    your_company_province: 'จังหวัดที่ตั้งของสถานที่ทำงาน',
    your_company_city: 'เขต/อำเภอที่ตั้งของสถานที่ทำงาน',
    your_company_zipcode: 'รหัสไปรษณีย์ของสถานที่ทำงาน',
    your_company_summary: 'ชื่อสถานที่ทำงานของคุณ',
    company_placholder: 'ตัวอย่างเช่น บริษัท ซาโตชิ จำกัด',
    occupation: 'อาชีพ',
    occupation_specify_detail: 'โปรดระบุ',
    occupation_specify_detail_placeholder: 'โปรดระบุ',
    avg_income: 'รายได้เฉลี่ยต่อเดือน',
    proof_of_income: 'เอกสารยืนยันรายได้',
    ex_proof_of_income_for_personal: 'เช่น รายงานการเคลื่อนไหวทางบัญชีธนาคาร, สลิปเงินเดือน, หลักฐานการจ่ายประกันสังคม เป็นต้น',
    ex_proof_of_income_for_org: 'เช่น รายงานการเคลื่อนไหวทางบัญชีธนาคาร เป็นต้น',
    doc_limit: 'ไฟล์เอกสารต้องน้อยกว่า',
    evidence_assets: 'หลักฐานการเป็นเจ้าของสินทรัพย์',
    ex_evidence_assets: 'เช่น รายงานการเคลื่อนไหวทางบัญชีธนาคาร, สลากออมสิน, โฉนดที่ดิน, สมุดทะเบียนรถยนต์ เป็นต้น',
    customer_address: 'ข้อมูลที่อยู่',
    origin_address: 'ที่อยู่ตามทะเบียนบ้าน',
    address_placeholder: 'กรอกที่อยู่',
    address_line_2: 'ที่อยู่บรรทัดที่ 2 (ถ้ามี)',
    address_line_2_summary: 'ที่อยู่บรรทัดที่ 2',
    country: 'ประเทศ',
    province: 'จังหวัด',
    province_placeholder: 'กรอกจังหวัด',
    city_placeholder: 'กรอกเขต',
    city: 'เขต/อำเภอ',
    zipcode: 'รหัสไปรษณีย์',
    current_addr_same_origin: 'ที่อยู่ปัจจุบันเหมือนกับที่อยู่ตามทะเบียนบ้าน',
    current_address: 'ที่อยู่ปัจจุบัน',
    customer_identification: 'บัตรประจำตัวลูกค้า',
    type_of_card: 'ประเภทของบัตร',
    id_card: 'บัตรประจำตัวประชาชน',
    passport: 'หนังสือเดินทาง',
    id_card_passport: 'บัตรประจำตัวประชาชน / หนังสือเดินทาง',
    id_card_placeholder: 'กรอกหมายเลขของคุณ',
    laser_code: 'เลขเลเซอร์',
    laser_code_placeholder: 'เช่น JT9999999999',
    ex_laser_code: 'ตัวอย่างเลขเลเซอร์',
    life_time_id_card: 'ไม่มีวันบัตรหมดอายุ',
    date_of_issue: 'วันออกบัตร',
    date_of_exp: 'วันบัตรหมดอายุ',
    photo_id_card: 'รูปบัตรประจำตัวประชาชนหรือหนังสือเดินทาง',
    photo_selfie: 'รูปถ่ายเซลฟีพร้อมเอกสารของคุณ',
    gov_issued: 'เอกสารที่ออกโดยหน่วยงานราชการ',
    upload_id_card: 'อัปโหลดภาพ{typeOfCard} (โปรดถ่ายภาพจากเอกสารตัวจริงเท่านั้น)',
    upload_gov_issued: 'อัปโหลดเอกสารที่ออกโดยหน่วยงานราชการเพื่อยืนยันตัวตนของคุณ เช่น ใบขับขี่',
    max_file_type: 'ขนาดไฟล์ไม่เกิน {0} MB และรองรับไฟล์ JPG, JPEG, PNG',
    upload_selfie: 'กรุณาใช้ภาพเซลฟีกับเอกสารของคุณเพื่อที่จะมองเห็นได้ชัดเจนและไม่ครอบคลุมใบหน้าของคุณ (โปรดถ่ายภาพคู่กับเอกสารตัวจริงเท่านั้น)',
    browse: 'เรียกดูภาพถ่ายของคุณ',
    browse_file: 'เรียกดูเอกสารของคุณ',
    ex_id_card: 'ตัวอย่าง {typeOfCard}',
    ex_selfie: 'ตัวอย่างภาพเซลฟีกับเอกสารของคุณ',
    terms: 'ข้อตกลงและเงื่อนไข',
    info_disclosure: 'ลูกค้าต้องเลื่อนอ่านข้อตกลงและเงื่อนไขก่อน จึงจะสามารถกดยอมรับข้อตกลงและเงื่อนไขได้',
    i_agree_terms: 'ฉันยอมรับข้อตกลงและเงื่อนไข',
    cert_not_over_six_months: 'ที่รับรองโดยกรมพัฒนาธุรกิจการค้าอายุไม่เกิน 6 เดือน',
    if_any: 'ถ้ามี',
    comp_cert_doc: 'หนังสือรับรองบริษัท',
    list_shareholders_doc: 'สำเนาบัญชีรายชื่อผู้ถือหุ้น (บอจ.5)',
    seal_cert_doc: 'สำเนาเอกสารรับรองตราประทับ (บอจ.3)',
    copy_house_registration: 'สำเนาทะเบียนบ้านของกรรมการผู้มีอำนาจลงนาม',
    power_attorney: 'หนังสือมอบอำนาจ',
    power_attorney_lowercase: 'หนังสือมอบอำนาจ',
    send_info_success: 'ส่งข้อมูลสำเร็จ',
    thanks_for_submited: 'ขอบคุณสำหรับการส่งข้อมูลของคุณ กรุณารอการตอบกลับผ่านอีเมล (หากคุณไม่ได้รับอีเมล กรุณาตรวจสอบที่ spam หรือ junk folder)',
    kyc_status: 'ดูสถานะการยืนยันตัวตน',
    org_info: 'ข้อมูลบริษัท',
    tax_id: 'เลขทะเบียนนิติบุคคล / หมายเลขประจำตัวของผู้เสียภาษี',
    business_type: 'ประเภทธุรกิจ',
    auth_represent: 'ตัวแทนผู้มีอำนาจ',
    auth_represent_subtitle: 'หากไม่มีการมอบอำนาจ ให้กรอกข้อมูลของกรรมการผู้มีอำนาจทำธุรกรรม แต่หากมีการมอบอำนาจ ให้กรอกข้อมูลของผู้รับมอบอำนาจ',
    auth_represent_info: 'ข้อมูลตัวแทนผู้มีอำนาจ',
    auth_represent_addr: 'ที่อยู่ตัวแทนผู้มีอำนาจ',
    auth_represent_identity: 'การยืนยันตัวตนของตัวแทนผู้มีอำนาจ',
    company_name: 'ชื่อบริษัท',
    company_address: 'ที่อยู่บริษัท',
    company_address_line_2: 'ที่อยู่บริษัทบรรทัดที่ 2 (ถ้ามี)',
    company_country: 'ประเทศ',
    company_province: 'จังหวัด',
    company_city: 'เขต/อำเภอ',
    company_zipcode: 'รหัสไปรษณีย์',
    company_tel_number: 'เบอร์โทรศัพท์บริษัท',
    company_tel_placeholder: 'ยกตัวอย่าง เช่น 0817766554',
    unverified: 'ไม่ได้ยืนยัน',
    request_change: 'ข้อมูลไม่ถูกต้อง',
    request_change_title: 'กรุณากรอกข้อมูลด้านล่างให้ถูกต้อง',
    request_change_detail: 'มีข้อมูลบางส่วนไม่ถูกต้องหรือมีคำขอให้เปลี่ยนแปลง หากต้องการความช่วยเหลือกรุณาติดต่อมาที่อีเมล support@kulap.io',
    request_change_kulap_plus_title: 'กรุณาอัปเดตข้อมูล KYC',
    request_change_kulap_plus_detail: 'กรุณาอัปเดตข้อมูล KYC ของคุณบนแพลตฟอร์ม Kulap Plus เพื่อให้สามารถใช้บริการของเราได้อย่างต่อเนื่อง คลิกที่ลิงก์ด้านล่างเพื่ออัปเดตข้อมูลของคุณ',
    request_change_kulap_plus_link_text: 'อัปเดต KYC บน Kulap Plus',
    request_change_kulap_plus_footer: 'หากคุณต้องการความช่วยเหลือ โปรดติดต่อ support@kulap.io',
    verifying: 'รอการตรวจสอบ',
    verifying_title: 'คุณได้ส่งข้อมูลสำเร็จแล้ว',
    verifying_detail: 'ขอบคุณสำหรับการส่งข้อมูล ทางทีมงานจะแจ้งผลการยืนยันตัวตนของคุณผ่านทางอีเมล (หากคุณไม่ได้รับอีเมล กรุณาตรวจสอบที่ spam หรือ junk folder)',
    rejected: 'ปฏิเสธการยืนยันตัวตน',
    rejected_title: 'การยืนยันตัวตนของคุณถูกปฏิเสธ',
    rejected_detail: 'การยืนยันตัวตนของคุณถูกปฏิเสธ',
    rejected_detail_2: 'ขอโทษอย่างสุดซึ้ง',
    rejected_detail_3: 'หากต้องการความช่วยเหลือกรุณาติดต่อมาที่อีเมล <a>support@kulap.io</a>',
    rejected_detail_4: 'ทีมช่วยเหลือ KULAP',
    approved: 'อนุมัติ',
    approved_title: 'การตรวจสอบเสร็จสมบูรณ์',
    approved_detail: 'เราได้ตรวจสอบข้อมูลของคุณเสร็จสิ้นแล้ว',
    detail_selfie: {
      l1: 'กรุณาใช้ภาพเซลฟี่กับเอกสารของคุณเพื่อที่จะมองเห็นได้ชัดเจนและไม่ครอบคลุมใบหน้าของคุณ',
      l2: 'โปรดถ่ายภาพคู่กับ<b>{typeOfCard}</b>',
      l3: 'เขียนในกระดาษ ลงลายมือ <b>ชื่อ-นามสกุล</b>',
      l4: 'เขียนในกระดาษ ระบุ<b>วัน-เดือน-ปี</b> ที่สมัคร',
      l5: 'เขียนในกระดาษ เขียนว่า<b>"KULAP"</b>'
    },
    facta_title: 'FATCA',
    facta_sub_title: 'ตามข้อกำหนดในการปฏิบัติตามกฎหมายว่าด้วยภาษีบัญชีต่างประเทศ (FATCA) บริษัท ซาโตชิ จำกัดต้องการให้คุณรองรับข้อมูลดังต่อไปนี้<br>(ข้อมูลเพิ่มเติม <a href="https://www.irs.gov" target="_blank">www.irs.gov</a>)',
    is_american: 'คุณเป็นพลเมืองของอเมริกาหรือไม่?',
    is_american_for_pay_tax: 'คุณเป็นผู้มีถิ่นที่อยู่ในอเมริกาเพื่อการเสียภาษีหรือไม่?',
    say_yes: 'ใช่',
    say_no: 'ไม่ใช่',
    american_tax_id: 'หมายเลขประจำตัวผู้เสียภาษีอเมริกา',
    american_tax_id_placeholder: 'กรอกหมายเลขประจำตัวผู้เสียภาษีอเมริกา'

  },
  forgot_password: {
    forgot_password: 'ลืมรหัสผ่าน?',
    sent: 'ส่งแล้ว!',
    please_check_your_email_and_confirm: 'กรุณายืนยันอีเมลของคุณเพื่อเปิดใช้งานบัญชีของคุณ',
    if_you_do_not_receive: `หากว่าคุณไม่ได้รับอีเมลจากเราภายในไม่กี่นาทีนี้ กรุณาตรวจสอบในสแปมอีเมล`,
    email_will_from: 'อีเมลจะถูกส่งโดย',
    enter_your_email: `กรุณากรอกอีเมลของคุณ แล้วเราจะส่งอีเมลพร้อมคำแนะนำในการรีเซ็ตรหัสผ่าน`,
    email: 'อีเมล',
    email_placeholder: 'เช่น abc@gmail.com'
  },
  reset_password: {
    reset_password: 'เปลี่ยนรหัสผ่าน'
  },
  send_confirm_email: {
    send_confirm_email: 'ส่งอีเมลยืนยันตัวตน',
    send_confirm_email_detail: 'กรุณากดปุ่มด้านล่างเพื่อส่งอีเมลยืนยันตัวตนไปยัง <b>{0}</b> แล้วโปรดตรวจสอบอีเมลของคุณเพื่อยืนยันตัวตน'
  },
  exchange: {
    metamask: 'Metamask',
    metamask_detail: 'ใช้งานง่ายบนคอมพิวเตอร์.',
    connect: 'เชื่อมต่อ',
    disconnect: 'ยกเลิกการเชื่อมต่อ',
    coming_soon: 'เร็ว ๆ นี้',
    install_metamask: 'ติดตั้ง Metamask',
    trezor: 'Trezor',
    trezor_detail: 'กระเป๋าเงินดิจิตอลที่ปลอดภัย ด้วยระบบฮาร์ดแวร์',
    ledger: 'Ledger',
    ledger_detail: 'กระเป๋าเงินดิจิตอลที่ปลอดภัย ด้วยระบบฮาร์ดแวร์',
    mobile_detail: 'ใช้งานง่ายบนมือถือ',
    wallet_connect: 'WalletConnect',
    from_token: 'เหรียญต้นทาง',
    max_balance: 'จำนวนทั้งหมด',
    to_token: 'เหรียญปลายทาง',
    estimate_rate: 'อัตราแลกเปลี่ยนประมาณการ',
    advanced_setting: 'ขั้นสูง',
    max_rate_change: 'ราคาผันผวนสูงสุด',
    max_slippage_detail: 'ธุรกรรมจะถูกยกเลิก ถ้ามูลค่าการแลกเปลี่ยนต่ำกว่าเปอร์เซ็นต์ที่กำหนดไว้',
    network_fee: 'ค่าธรรมเนียมเครือข่าย',
    network_fee_detail: 'ต้นทุนในการทำธุรกรรมบนบล็อกเชน',
    platform_fee: 'ค่าธรรมเนียมแพลตฟอร์ม',
    platform_fee_detail: 'ค่าธรรมเนียมบนแพลตฟอร์ม KULAP',
    estimate_time: 'ใช้เวลายืนยัน',
    minutes: 'นาที',
    slow: 'ช้า',
    standard: 'ปานกลาง',
    fast: 'เร็ว',
    exchange_token: 'แลกเปลี่ยน',
    estimate_balance: 'สินทรัพย์รวม',
    connected: 'เชื่อมต่ออยู่',
    metamask_help: 'ข้อมูลเพิ่มเติม',
    cipher_help: 'ข้อมูลเพิ่มเติม',
    coin_base_wallet_help: 'ข้อมูลเพิ่มเติม',
    trust_help: 'ข้อมูลเพิ่มเติม',
    wallet_connect_help: 'ข้อมูลเพิ่มเติม',
    address_lowercase: 'adresss',
    address_uppercase: 'ADDRESS',
    token_balance: 'ยอดเงิน',
    see_more: 'ดูเพิ่มเติม',
    see_less: 'ดูน้อยลง',
    token_name: 'สกุลเงิน',
    change_24_hr: 'เปลี่ยนแปลง 24 ชั่วโมง',
    price_usd: 'ราคาล่าสุด (USD)',
    buy_sell_token: 'ซื้อ / ขาย',
    buy: 'ซื้อ',
    sell: 'ขาย',
    confirm_exchange: 'ยืนยันการซื้อขาย',
    gas_price_notice: 'ข้อควรระวัง',
    gas_price_notice_detail: 'การปรับราคา Gas อาจส่งผลให้การซื้อขายไม่สำเร็จ',
    confirm: 'ยืนยัน',
    allow_exchange: 'ยินยอมการซื้อขาย',
    allow_exchange_detail: 'ยินยอมให้ระบบซื้อขายเหรียญ {0} ของท่าน',
    your_address_is: 'Address ของท่าน',
    approve: 'อนุมัติ',
    on_process: 'กำลังดำเนินการ',
    tx_is_pending_text: 'คำสั่งซื้อขายของท่านกำลังประมวลผลบน blockchain',
    you_can_view_tx: 'ดูรายการของท่านได้ที่',
    failed: 'ไม่สำเร็จ',
    failed_detail: 'การซื้อขายของท่านไม่สำเร็จ',
    rate: 'อัตราแลกเปลี่ยน',
    complete: 'สำเร็จ',
    complete_detail: 'การซื้อขายของท่านสำเร็จแล้ว',
    token_can_not_be_exchanged: 'เหรียญโทเคนไม่สามารถแลกเปลี่ยนได้',
    token_can_not_be_exchanged_detail: 'คุณต้องยืนยันตัวตนตามเงื่อนไขนี้',
    kyc_detail: 'ผู้ใช้งานกรอกเอกสารการยืนยันตัวตน และอัปโหลดเอกสารเพิ่มเติม',
    suit_test_detail: 'แบบสอบถามเพื่อประเมินความเหมาะสมในการลงทุนของลูกค้า',
    knowledge_test_detail: 'แบบสอบถามเพื่อประเมินความรู้ในการลงทุนของลูกค้า',
    confirm_email: 'ยืนยันอีเมล',
    confirm_email_detail: 'กรุณายืนยันอีเมลหลังจากลงทะเบียนเสร็จสิ้น',
    select_token: 'เลือกเหรียญโทเคน',
    select_token_placeholder: 'ค้นหาเหรียญโทเคน',
    invalid_price_slippage_value: 'ราคาผันผวนต้องอยู่ระหว่าง 0% ถึง 10%'
  },
  suit_test: {
    country: 'ประเทศที่ {index}',
    q_1: {
      q: 'ลูกค้าอายุเท่าไหร่',
      a_1: 'ต่ำกว่า 20 ปี',
      a_2: 'ตั้งแต่ 20 ปี แต่ไม่เกิน 30 ปี',
      a_3: 'ตั้งแต่ 30 ปี แต่ไม่เกิน 45 ปี',
      a_4: 'ตั้งแต่ 45 ปี แต่ไม่เกิน 60 ปี',
      a_5: '60 ปีขึ้นไป'
    },
    q_2: {
      q: 'การศึกษา',
      a_1: 'ต่ำกว่าปริญญาตรี',
      a_2: 'ปริญญาตรี',
      a_3: 'สูงกว่าปริญญาตรี'
    },
    q_3: {
      q: 'วัตถุประสงค์ของการสมัครใช้บริการ (สามารถเลือกได้มากกว่า 1 ข้อ)',
      a_1: `เพื่อการออม`,
      a_2: 'เพื่อการลงทุน',
      a_3: 'เพื่อโอนสินทรัพย์ดิจิทัลระหว่างประเทศ',
      a_4: 'เพื่อซื้อโทเคนระดมทุน (ICO)',
      a_5: 'อื่น ๆ'
    },
    q_4: {
      q: 'ระยะเวลาการลงทุน (ระยะเวลาที่คาดว่าจะลงทุนในสินทรัพย์ดิจิทัลแต่ละครั้ง)',
      a_1: `ระยะสั้น ไม่เกิน 1 เดือน`,
      a_2: 'เกินกว่า 1 เดือน แต่ไม่เกิน 6 เดือน',
      a_3: 'เกินกว่า 6 เดือน แต่ไม่เกิน 1 ปี',
      a_4: 'เกินกว่า 1 ปี แต่ไม่เกิน 3 ปี',
      a_5: '3 ปีขึ้นไป'
    },
    q_5: {
      q: 'แหล่งที่มาของเงินได้ (สามารถเลือกได้มากกว่า 1 ข้อ)',
      a_1: `เงินออม`,
      a_2: 'เงินเดือน/ค่าจ้าง',
      a_3: 'มรดก/ของขวัญ',
      a_4: 'ธุรกิจส่วนตัว',
      a_5: 'ตราสาร/กองทุน',
      a_6: 'ผู้ปกครอง',
      a_7: 'อื่น ๆ'
    },
    q_6: {
      q: 'แหล่งที่มารายได้มาจากประเทศใด',
      a_1: `แหล่งที่มารายได้มาจากประเทศเดียว`,
      a_2: 'แหล่งที่มารายได้มาจากประเทศไทยเกินกว่าร้อยละ 80 และต่างประเทศ',
      a_3: 'แหล่งที่มารายได้มาจากประเทศไทยต่ำกว่าร้อยละ 80 และต่างประเทศ',
      a_4: 'แหล่งที่มารายได้มาจากต่างประเทศ 2 ประเทศ',
      a_5: 'แหล่งที่มารายได้มาจากต่างประเทศมากกว่า 2 ประเทศ'
    },
    q_7: {
      q: 'รายได้เฉลี่ยต่อเดือน',
      a_1: `น้อยกว่า 10,000 บาท (น้อยกว่า 300 USD)`,
      a_2: '10,000 - 14,999 บาท (300 USD - 449 USD)',
      a_3: '15,000 - 34,999 บาท (450 USD - 999 USD)',
      a_4: '35,000 - 49,999 บาท (1,000 USD - 1,499 USD)',
      a_5: '50,000 - 99,999 บาท (1,500 USD - 2,999 USD)',
      a_6: '100,000 - 499,999 บาท (3,000 USD - 14,999 USD)',
      a_7: 'มากกว่า 500,000 บาท (มากกว่า 15,000 USD)'
    },
    q_8: {
      q: 'ปริมาณสินทรัพย์ทั้งหมดที่ลูกค้าเป็นเจ้าของ',
      a_1: `น้อยกว่า 500,000 บาท (น้อยกว่า 15,000 USD)`,
      a_2: '500,000 - 1,000,000 บาท (15,000 USD - 29,999 USD)',
      a_3: '1,000,000 - 5,000,000 บาท (30,000 USD - 149,999 USD)',
      a_4: '5,000,000 - 10,000,000 บาท (150,000 USD - 299,999 USD)',
      a_5: '10,000,000 - 100,000,000 บาท (300,000 USD - 2,999,999 USD)',
      a_6: 'มากกว่า 100,000,000 บาท (มากกว่า 3,000,000 USD)'
    },
    q_9: {
      q: 'สัดส่วนการลงทุนระหว่างสินทรัพย์ดิจิทัลกับสินทรัพย์ทั้งหมด',
      a_1: `น้อยกว่าร้อยละ 10`,
      a_2: 'ตั้งแต่ร้อยละ 10 แต่ไม่เกินร้อยละ 30',
      a_3: 'ตั้งแต่ร้อยละ 30 แต่ไม่เกินร้อยละ 50',
      a_4: 'ตั้งแต่ร้อยละ 50 แต่ไม่เกินร้อยละ 80',
      a_5: 'ตั้งแต่ร้อยละ 80 ขึ้นไป'
    },
    q_10: {
      q: 'ท่านมีประสบการณ์การลงทุนในหลักทรัพย์หรือไม่ (หลักทรัพย์ หมายถึง หน่วยลงทุน หุ้น หุ้นกู้ พันธบัตรรัฐบาล ตราสารอนุพันธ์ สินทรัพย์ดิจิทัล หรือเครื่องมือทางการเงินอื่นทำนองเดียวกัน)',
      a_1: `ไม่มีประสบการณ์เลย`,
      a_2: 'มีประสบการณ์ไม่เกิน 1 ปี',
      a_3: 'มีประสบการณ์ตั้งแต่ 1 ปี แต่ไม่เกิน 3 ปี',
      a_4: 'มีประสบการณ์ตั้งแต่ 3 ปี แต่ไม่เกิน 10 ปี',
      a_5: 'มีประสบการณ์ตั้งแต่ 10 ปีขึ้นไป'
    },
    q_11: {
      q: 'ระดับความเสี่ยงของการลงทุนที่ยอมรับได้',
      a_1: `รับความเสี่ยงไม่ได้ ชอบการลงทุนที่ปลอดภัย สร้างรายได้ประจำ แม้ว่าผลตอบแทนต่ำ`,
      a_2: 'รับความเสี่ยงได้พอควร เพื่อเพิ่มโอกาสที่จะได้รับผลตอบแทนที่สูงขึ้นในระยะยาว',
      a_3: 'รับความเสี่ยงได้สูง เพื่อเพิ่มโอกาสที่จะได้รับผลตอบแทนที่สูงกว่าในระยะยาว',
      a_4: 'รับความเสี่ยงได้สูงมาก เพื่อสร้างโอกาสที่จะได้รับผลตอบแทนสูงสุดจากการลงทุน'
    },
    q_12: {
      q: 'ท่านคิดว่าท่านยอมรับผลขาดทุนจากการลงทุนในครั้งหนึ่งได้มากน้อยเพียงใด',
      a_1: `ไม่สามารถรับผลขาดทุนได้เลย`,
      a_2: 'ต่ำกว่าร้อยละ 10 ของเงินลงทุน',
      a_3: 'ประมาณร้อยละ 10 - 30 ของเงินลงทุน',
      a_4: 'ประมาณร้อยละ 30 - 70 ของเงินลงทุน',
      a_5: 'รับผลขาดทุนได้ทั้งหมด'
    },
    q_13: {
      q: 'เคยถูกศาลพิพากษาให้มีความผิดในฐานความผิดที่เกี่ยวข้องกับทรัพย์สิน หรือถูกศาลมีคำสั่งให้ทรัพย์สินตกเป็นของแผ่นดิน หรือไม่',
      a_1: 'ไม่เคย',
      a_2: 'เคย'
    },
    q_14: {
      q: 'เคยถูกเรียกให้แสดงบัญชีรายการทรัพย์สินต่อหน่วยงานภาครัฐ เช่น สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ สำนักงานป้องกันและปราบปรามการฟอกเงิน หรือไม่',
      a_1: 'ไม่เคย',
      a_2: 'เคย'
    },
    alert_message: '*โปรดอ่านข้อความหรือเลื่อนดูข้อความจนสุดบรรทัด',
    accept_acknowledge_risk: 'ข้าพเจ้าได้อ่าน และตกลงยินยอมตามรายละเอียดข้อตกลงและความยินยอมข้างต้น'
  },
  knowledge_test: {
    blockchain_basic: {
      q_1: {
        q: 'ก่อนที่จะเกิดเทคโนโลยีบล็อกเชน ข้อมูลอิเล็กทรอนิกส์มีข้อเสียด้านใด',
        a_1: 'ข้อมูลถูกปลอมแปลงได้ง่าย',
        a_2: 'ข้อมูลไม่สามารถถูกแก้ไขได้',
        a_3: 'ข้อมูลถ่ายโอนได้ช้า'
      },
      q_2: {
        q: 'เทคโนโลยีบล็อกเชนถูกนำเสนอครั้งแรกในสินทรัพย์ดิจิทัลประเภทใด',
        a_1: 'ไลท์คอยน์',
        a_2: 'บิทคอยน์',
        a_3: 'เอ็กอาร์พี'
      },
      q_3: {
        q: 'บิทคอยน์มีจำนวนเท่าใด',
        a_1: '21 ล้านบิทคอยน์',
        a_2: '1 ล้านบิทคอยน์',
        a_3: 'ไม่จำกัดจำนวน'
      },
      q_4: {
        q: 'เมื่อบิทคอยน์ผลิตขึ้นมา 21 ล้านบิทคอยน์แล้วจะเกิดสิ่งใดขึ้น',
        a_1: 'จะผลิตต่อเนื่องไปในอัตราคงที่',
        a_2: 'ไม่มีการผลิตบิทคอยน์ขึ้นมาใหม่',
        a_3: 'จะทำลายบิทคอยน์ทุก ๆ 30 นาที'
      },
      q_5: {
        q: 'เทคโนโลยีใดที่ถูกระบุอยู่ในหนังสือชี้ชวนของบิทคอยน์',
        a_1: 'เทคโนโลยีบล็อกเชน',
        a_2: 'วิทยาการเข้ารหัส',
        a_3: 'ถูกทุกข้อ'
      },
      q_6: {
        q: 'ข้อใดคือวัตถุประสงค์ในการสร้างบิทคอยน์',
        a_1: 'สร้างระบบการเงินที่สนับสนุนโดยรัฐบาล',
        a_2: 'สร้างระบบการเงินอิเล็กทรอนิกส์ที่ปราศจากตัวกลาง',
        a_3: 'สร้างระบบการโอนเงินระหว่างประเทศ'
      },
      q_7: {
        q: 'ข้อใดคือคุณลักษณะเฉพาะของบิทคอยน์',
        a_1: 'ช่วยเพื่อประสิทธิภาพในการทำงานของธนาคารพาณิชย์',
        a_2: 'การทำธุรกรรมไม่ต้องพึ่งพาคนกลาง',
        a_3: 'การโอนสินทรัพย์ดิจิทัลมีความรวดเร็วมากกว่าสินทรัพย์ดิจิทัลอื่น'
      },
      q_8: {
        q: 'หน่วยย่อยที่สุดของบิทคอยน์คือทศนิยมกี่ตำแหน่ง',
        a_1: 'บิทคอยน์ไม่มีหน่วยย่อยหรือทศนิยม',
        a_2: 'มีทศนิยม 2 ตำแหน่ง',
        a_3: 'มีทศนิยม 8 ตำแหน่ง'
      },
      q_9: {
        q: 'หน่วยย่อยที่สุดของบิทคอยน์เรียกว่าอะไร',
        a_1: 'ซาโตชิ',
        a_2: 'บิทคอยน์ แคช',
        a_3: 'บิทคอยน์ มินิ'
      },
      q_10: {
        q: 'บิทคอยน์สามารถนำไปใช้ทำอะไรได้บ้าง',
        a_1: 'ซื้อสินค้าและบริการ',
        a_2: 'ลงทุนใน ICO',
        a_3: 'ถูกทุกข้อ'
      },
      q_11: {
        q: 'ผู้ใดสามารถตรวจสอบ source code ของบิทคอยน์ได้',
        a_1: 'นักพัฒนา Bitcoin core',
        a_2: 'ทุกคนสามารถตรวจสอบได้',
        a_3: 'คณะกรรมการ ก.ล.ต.'
      },
      q_12: {
        q: 'Source code ของบิทคอยน์สามารถตรวจสอบได้จากที่ใด',
        a_1: 'Github',
        a_2: 'ETDA',
        a_3: 'สำนักงาน ก.ล.ต.'
      },
      q_13: {
        q: 'ซาโตชิ คืออะไร',
        a_1: 'หน่วยย่อยที่สุดของบิทคอยน์',
        a_2: 'อุปกรณ์ที่ใช้จัดเก็บสินทรัพย์ดิจิทัล',
        a_3: 'ชื่อเรียกอีกอย่างหนึ่งของ Private Key'
      },
      q_14: {
        q: 'mBTC มีมูลค่าเท่ากับเท่าใด',
        a_1: '1 ล้านบิทคอยน์ ',
        a_2: '1 บิทคอยน์',
        a_3: '0.001 บิทคอยน์'
      },
      q_15: {
        q: 'ข้อใดไม่ใช่ลักษณะการเก็บข้อมูลของบล็อกเชน',
        a_1: 'การออกแบบโครงสร้างเป็นกล่อง (block)',
        a_2: 'การกระจายสถานที่จัดเก็บข้อมูลหลายแห่ง',
        a_3: 'การเก็บข้อมูลแบบรวมศูนย์กลาง'
      },
      q_16: {
        q: 'เทคโนโลยีบล็อกเชนเกิดขึ้นเพื่อแก้ปัญหาใด',
        a_1: 'การปลอมแปลงข้อมูล',
        a_2: 'ความถูกต้องของข้อมูล',
        a_3: 'ความรวดเร็วในการโอนถ่ายข้อมูล'
      },
      q_17: {
        q: 'ข้อใดคือประโยชน์ของเทคโนโลยีบล็อกเชน',
        a_1: 'สามารถตรวจสอบข้อมูลซึ่งกันและกันได้',
        a_2: 'ข้อมูลถูกควบคุมโดยศูนย์กลาง',
        a_3: 'สามารถพิสูจน์ได้ว่าข้อมูลนั้นถูกต้องตรงกับความเป็นจริง'
      },
      q_18: {
        q: 'ข้อใดคือลักษณะการเก็บข้อมูลของบล็อกเชน',
        a_1: 'มีการอ้างอิงข้อมูลแบบห่วงโซ่',
        a_2: 'เก็บข้อมูลขนาดเล็กเพื่อให้สามารถเก็บข้อมูลจำนวนมากได้',
        a_3: 'ถูกทุกข้อ'
      },
      q_19: {
        q: 'บิทคอยน์ยืนยันธุรกรรมหนึ่งครั้งใช้เวลาประมาณเท่าใด',
        a_1: 'ทุกวินาที',
        a_2: 'ทุกสิบนาที',
        a_3: 'ทุกหนึ่งชั่วโมง'
      },
      q_20: {
        q: 'Block reward คืออะไร',
        a_1: 'รางวัลที่ผู้ยืนยันธุรกรรมได้รับจากการยืนยันธุรกรรม',
        a_2: 'รางวัลที่ผู้ผลิตโทเคนดิจิทัลได้รับจากการระดมทุนได้สำเร็จ',
        a_3: 'รางวัลที่ซื้อโทเคนดิจิทัลจากการระดมทุนได้เป็นคนแรก'
      }
    },
    investment: {
      q_1: {
        q: 'Address มีลักษณะคล้ายคลึงกับสิ่งใดในระบบบัญชีธนาคาร',
        a_1: 'รหัสผ่าน',
        a_2: 'เลขที่บัญชี',
        a_3: 'รหัสการทำธุรกรรม'
      },
      q_2: {
        q: 'บุคคลหนึ่งคนสามารถมี Address ได้จำนวนเท่าใด',
        a_1: 'Address เดียวเท่านั้น',
        a_2: 'ตามจำนวนที่คณะกรรมการ ก.ล.ต. กำหนด',
        a_3: 'ไม่จำกัดจำนวน'
      },
      q_3: {
        q: 'ข้อแตกต่างของ Address กับบัญชีธนาคารคืออะไร',
        a_1: 'Address ไม่มีข้อมูลส่วนบุคคล',
        a_2: 'Address ถูกควบคุมโดยศูนย์ซื้อขายสินทรัพย์ดิจิทัล',
        a_3: 'การเปิด Address จะต้องขึ้นทะเบียนกับคณะกรรมการ ก.ล.ต.'
      },
      q_4: {
        q: 'ผู้รับโอนสินทรัพย์ดิจิทัลจะต้องมอบสิ่งใดให้แก่ผู้โอน',
        a_1: 'Private key',
        a_2: 'Address',
        a_3: 'Email'
      },
      q_5: {
        q: 'ข้อควรระวังในการโอนสินทรัพย์ดิจิทัลคืออะไร',
        a_1: 'ตรวจสอบ Address ของผู้รับโอนให้ถูกต้อง',
        a_2: 'กำชับผู้โอนว่าห้ามเปิดเผย Private key ของผู้รับโอน',
        a_3: 'ห้ามส่ง Address ของผู้รับโอนให้แก่ผู้โอน'
      },
      q_6: {
        q: 'Private Key มีลักษณะคล้ายคลึงกับสิ่งใดมากที่สุด',
        a_1: 'Password',
        a_2: 'Username',
        a_3: 'Email'
      },
      q_7: {
        q: 'ผู้ถือครองสินทรัพย์ดิจิทัลควรเก็บรักษาสิ่งใดไว้เป็นความลับ',
        a_1: 'Address',
        a_2: 'Email',
        a_3: 'Private key'
      },
      q_8: {
        q: 'ข้อใดมิใช่ประเภทของ Wallet',
        a_1: 'Hot wallet',
        a_2: 'Cold storage',
        a_3: 'Safety express'
      },
      q_9: {
        q: 'Wallet แบบใดที่ผู้ใช้งานจะเป็นผู้เก็บ private key ด้วยตนเอง',
        a_1: 'Hot wallet',
        a_2: 'Cold storage',
        a_3: 'ถูกทุกข้อ'
      },
      q_10: {
        q: 'Wallet แบบใดที่ผู้ให้บริการจะเป็นผู้เก็บ private key แทนลูกค้า',
        a_1: 'Hot wallet',
        a_2: 'Cold storage',
        a_3: 'Paper wallet'
      },
      q_11: {
        q: 'ข้อใดเป็นชื่ออุปกรณ์ของ Hardware wallet',
        a_1: 'Coinman',
        a_2: 'Cryptoventure',
        a_3: 'Trezor'
      },
      q_12: {
        q: 'Wallet ประเภทใดที่มีราคาสูงที่สุด',
        a_1: 'Hot wallet',
        a_2: 'Paper wallet',
        a_3: 'Hardware wallet'
      },
      q_13: {
        q: 'หากนาย ก ซื้อบิทคอยน์มูลค่า 30 ล้านบาท นาย ก ควรเก็บบิทคอยน์ไว้ที่ใดจึงปลอดภัยที่สุด',
        a_1: 'ธนาคารพาณิชย์',
        a_2: 'ศูนย์ซื้อขายสินทรัพย์ดิจิทัลในต่างประเทศ',
        a_3: 'Hardware wallet'
      },
      q_14: {
        q: 'การเก็บรักษาทรัพย์สินดิจิทัลแบบใดมีความปลอดภัยน้อยที่สุด',
        a_1: 'จัดเก็บ Private key ไว้ในคอมพิวเตอร์',
        a_2: 'จัดเก็บ Private key ไว้ใน Paper wallet',
        a_3: 'จัดเก็บ Private key ไว้ใน Hardware wallet'
      },
      q_15: {
        q: 'การเก็บรักษาทรัพย์สินดิจิทัลแบบใดมีความปลอดภัยมากที่สุด',
        a_1: 'จัดเก็บ Private key ไว้ในคอมพิวเตอร์',
        a_2: 'จัดเก็บ Private key ไว้ใน Paper wallet',
        a_3: 'จัดเก็บไว้กับศูนย์ซื้อขายสินทรัพย์ดิจิทัลที่ไม่ได้รับใบอนุญาตจากคณะกรรมการ ก.ล.ต.'
      },
      q_16: {
        q: 'นาย ก จัดเก็บสินทรัพย์ดิจิทัลด้วยตนเองโดยวิธี Paper wallet หากนาย ก ทำ Paper wallet หาย นาย ก จะกู้ Private key ได้อย่างไร',
        a_1: 'แจ้งคณะกรรมการ ก.ล.ต.',
        a_2: 'แจ้งธนาคารแห่งประเทศไทย',
        a_3: 'ไม่สามารถกู้รหัสผ่านคืนได้'
      },
      q_17: {
        q: 'นาย ก จัดเก็บสินทรัพย์ดิจิทัลด้วยตนเองโดยใช้ Hardware wallet (Trezor) หากนาย ก ทำ Trezor หาย นาย ก จะกู้ Private key ได้อย่างไร',
        a_1: 'แจ้งคณะกรรมการ ก.ล.ต.',
        a_2: 'ใช้ seed ที่สำรองไว้',
        a_3: 'ไม่สามารถกู้รหัสผ่านคืนได้'
      },
      q_18: {
        q: 'นาย ก ใช้บริการซื้อขายสินทรัพย์ดิจิทัลผ่านศูนย์ซื้อขายสินทรัพย์ดิจิทัล หากนาย ก ลืมรหัสผ่าน นาย ก จะกู้รหัสผ่านได้อย่างไร',
        a_1: 'แจ้งคณะกรรมการ ก.ล.ต.',
        a_2: 'แจ้งศูนย์ซื้อขายสินทรัพย์ดิจิทัล',
        a_3: 'ไม่สามารถกู้รหัสผ่านคืนได้'
      },
      q_19: {
        q: 'นักลงทุนสามารถตรวจสอบผลการโอนสินทรัพย์ดิจิทัลได้จากที่ใด',
        a_1: 'Blockexplorer',
        a_2: 'Blockcypher',
        a_3: 'ถูกทุกข้อ'
      },
      q_20: {
        q: 'นักลงทุนสามารถใช้สิ่งใดในการตรวจสอบผลการทำธุรกรรม',
        a_1: 'Address',
        a_2: 'Transaction ID',
        a_3: 'ถูกทุกข้อ'
      }
    },
    legal: {
      q_1: {
        q: 'หน่วยงานที่ทำหน้าที่กำกับผู้ประกอบธุรกิจสินทรัพย์ดิจิทัลภายใต้พระราชกำหนดสินทรัพย์ดิจิทัลคือหน่วยงานใด',
        a_1: 'ธนาคารแห่งประเทศไทย',
        a_2: 'คณะกรรมการ ก.ล.ต.',
        a_3: 'กรมสรรพากร'
      },
      q_2: {
        q: 'นักลงทุนสามารถตรวจสอบรายชื่อผู้ประกอบธุรกิจสินทรัพย์ดิจิทัลที่ได้รับอนุญาตจากที่ใด',
        a_1: 'ธนาคารแห่งประเทศไทย',
        a_2: 'สำนักงานคณะกรรมการ ก.ล.ต.',
        a_3: 'สมาคมไทยบล็อกเชน'
      },
      q_3: {
        q: 'คริปโทเคอร์เรนซีมีสถานะทางกฎหมายในประเทศไทยอย่างไร',
        a_1: 'เป็นสิ่งผิดกฎหมาย',
        a_2: 'เป็นข้อมูลทางอิเล็กทรอนิกส์',
        a_3: 'เป็นสกุลเงินประเภทหนึ่ง'
      },
      q_4: {
        q: 'บิทคอยน์มีสถานะทางกฎหมายในประเทศไทยอย่างไร',
        a_1: 'เป็นสินทรัพย์',
        a_2: 'เป็นสกุลเงินประเภทหนึ่ง',
        a_3: 'ไม่ได้รับการรับรองตามกฎหมาย'
      },
      q_5: {
        q: 'JFin Coin มีสถานะทางกฎหมายในประเทศไทยอย่างไร',
        a_1: 'เป็นโทเคนดิจิทัล',
        a_2: 'เป็นสกุลเงินประเภทหนึ่ง',
        a_3: 'ไม่ได้รับการรับรองตามกฎหมาย'
      },
      q_6: {
        q: 'สินทรัพย์ดิจิทัลใดดังต่อไปนี้ ไม่ใช่สินทรัพย์ดิจิทัลที่คณะกรรมการ ก.ล.ต. ประกาศกำหนดให้เป็นคริปโทเคอร์เรนซีที่ผู้ประกอบธุรกิจสินทรัพย์ดิจิทัลสามารถรับทำธุรกรรม',
        a_1: 'บิทคอยน์ (Bitcoin)',
        a_2: 'ริปเปิ้ล (XRP)',
        a_3: 'เจฟินคอยน์ (JFin coin)'
      },
      q_7: {
        q: 'สินทรัพย์ดิจิทัลใดดังต่อไปนี้ ไม่ใช่สินทรัพย์ดิจิทัลที่คณะกรรมการ ก.ล.ต. ประกาศกำหนดให้เป็นคริปโทเคอร์เรนซีที่ผู้ประกอบธุรกิจสินทรัพย์ดิจิทัลสามารถรับทำธุรกรรม',
        a_1: 'อีเธอเรียม คลาสสิค (Ethereum Classic)',
        a_2: 'เดฟ เน็ตเวิร์ค (Dev Network)',
        a_3: 'สเตลล่า (Stellar)'
      },
      q_8: {
        q: 'ผู้ประกอบธุรกิจประเภทใดเป็นศูนย์กลางเพื่ออำนวยความสะดวกให้ผู้ซึ่งประสงค์จะซื้อขายหรือแลกเปลี่ยนสินทรัพย์ดิจิทัลสามารถทำความตกลงหรือจับคู่กันได้',
        a_1: 'ศูนย์ซื้อขายสินทรัพย์ดิจิทัล (Exchange)',
        a_2: 'นายหน้าซื้อขายสินทรัพย์ดิจิทัล (Broker)',
        a_3: 'ผู้ค้าสินทรัพย์ดิจิทัล (Dealer)'
      },
      q_9: {
        q: 'ผู้ประกอบธุรกิจประเภทใดให้บริการเป็นตัวแทนเพื่อซื้อขายหรือแลกเปลี่ยนสินทรัพย์ดิจิทัลให้แก่บุคคลอื่นโดยกระทำเป็นทางค้าปกติ',
        a_1: 'ศูนย์ซื้อขายสินทรัพย์ดิจิทัล (Exchange)',
        a_2: 'นายหน้าซื้อขายสินทรัพย์ดิจิทัล (Broker)',
        a_3: 'ผู้ค้าสินทรัพย์ดิจิทัล (Dealer)'
      },
      q_10: {
        q: 'ผู้ประกอบธุรกิจประเภทใดแสดงต่อบุคคลทั่วไปว่าพร้อมจะให้บริการซื้อขายหรือแลกเปลี่ยนสินทรัพย์ดิจิทัลในนามของตนเองเป็นทางค้าปกติ',
        a_1: 'ศูนย์ซื้อขายสินทรัพย์ดิจิทัล (Exchange)',
        a_2: 'นายหน้าซื้อขายสินทรัพย์ดิจิทัล (Broker)',
        a_3: 'ผู้ค้าสินทรัพย์ดิจิทัล (Dealer)'
      },
      q_11: {
        q: 'ผู้ประกอบธุรกิจประเภทใดทำหน้าที่กลั่นกรองลักษณะของโทเคนดิจิทัลที่จะเสนอขาย',
        a_1: 'ศูนย์ซื้อขายสินทรัพย์ดิจิทัล (Exchange)',
        a_2: 'ผู้ให้บริการระบบเสนอขายโทเคนดิจิทัล (ICO Portal)',
        a_3: 'ผู้ค้าสินทรัพย์ดิจิทัล (Dealer)'
      },
      q_12: {
        q: 'อะไรคือข้อดีของการซื้อขายสินทรัพย์ดิจิทัลโดยใช้บริการของผู้ประกอบธุรกิจสินทรัพย์ดิจิทัล',
        a_1: 'ได้รับการตรวจสอบมาตรฐานจากหน่วยงานภาครัฐ',
        a_2: 'หากเกิดความเสียหาย นักลงทุนจะได้รับบริการฟ้องร้องดำเนินคดีจากหน่วยงานภาครัฐโดยไม่ต้องเสียค่าใช้จ่าย',
        a_3: 'ถูกทุกข้อ'
      },
      q_13: {
        q: 'ผู้ประกอบธุรกิจใดต่อไปนี้ไม่ต้องได้รับอนุญาตจากคณะกรรมการ ก.ล.ต.',
        a_1: 'ผู้ประกอบธุรกิจขุดบิทคอยน์',
        a_2: 'ผู้ให้บริการระบบเสนอขายโทเคนดิจิทัล (ICO Portal)',
        a_3: 'ผู้ค้าสินทรัพย์ดิจิทัล (Dealer)'
      },
      q_14: {
        q: 'หลัก Segregated account คืออะไร',
        a_1: 'การที่ผู้ประกอบธุรกิจจะต้องจัดส่งข้อมูลลูกค้าให้แก่คณะกรรมการ ก.ล.ต.',
        a_2: 'การที่ผู้ประกอบธุรกิจจะต้องจัดทำบัญชีทรัพย์สินของลูกค้าแยกออกจากบัญชีทรัพย์สินของตน',
        a_3: 'การที่ผู้ประกอบธุรกิจจะต้องตรวจสอบบัญชีลูกค้าอย่างสม่ำเสมอ'
      },
      q_15: {
        q: 'ในกรณีลูกค้าฝากสินทรัพย์ดิจิทัลของตนเองไว้กับผู้ประกอบธุรกิจสินทรัพย์ดิจิทัล สินทรัพย์ดิจิทัลนั้นถือว่าเป็นทรัพย์สินของผู้ใด',
        a_1: 'ผู้ประกอบธุรกิจสินทรัพย์ดิจิทัล',
        a_2: 'ลูกค้า',
        a_3: 'คณะกรรมการ ก.ล.ต.'
      },
      q_16: {
        q: 'หลัก Insider Trading คืออะไร',
        a_1: 'การห้ามมิให้พนักงานของบริษัทฯ ใช้บริการซื้อขายแลกเปลี่ยนสินทรัพย์ดิจิทัลของบริษัทฯ ตนเอง',
        a_2: 'การห้ามมิให้พนักงานของบริษัทฯ นำข้อมูลส่วนบุคคลของลูกค้าไปซื้อขายแลกเปลี่ยน',
        a_3: 'การห้ามมิให้ผู้ล่วงรู้ข้อมูลภายในเกี่ยวกับสินทรัพย์ดิจิทัลซื้อขายแลกเปลี่ยนสินทรัพย์ดิจิทัลดังกล่าว'
      },
      q_17: {
        q: 'การกระทำใดดังต่อไปนี้ มิใช่ความผิดตามพระราชกำหนดการประกอบธุรกิจสินทรัพย์ดิจิทัล',
        a_1: 'การใช้ข้อมูลภายใน (Insider Trading)',
        a_2: 'การทำกำไรระหว่างสองตลาด (Arbitrage Trading)',
        a_3: 'การสร้างราคาหรือการปั่นราคา (Market Manipulation)'
      },
      q_18: {
        q: 'การซื้อขายแลกเปลี่ยนโดยมีเจตนาบิดเบือนราคาและปริมาณการซื้อขายสินทรัพย์ดิจิทัลให้ผิดไปจากสภาพปกติ เพื่อให้บุคคลทั่วไปสำคัญผิดเกี่ยวกับราคาหรือปริมาณการซื้อขาย และหวังผลประโยชน์จากการบิดเบือนนั้น เป็นความผิดฐานใด',
        a_1: 'การใช้ข้อมูลภายใน (Insider Trading)',
        a_2: 'การทำกำไรระหว่างสองตลาด (Arbitrage Trading)',
        a_3: 'การสร้างราคาหรือการปั่นราคา (Market Manipulation)'
      },
      q_19: {
        q: 'การกระทำใดดังต่อไปนี้ กฎหมายให้สันนิษฐานว่าเป็นตัวการในการกระทำความผิด (ผู้ร่วมกระทำความผิด)',
        a_1: 'ยอมให้ผู้อื่นใช้บัญชีธนาคารร่วมกับตนเอง',
        a_2: 'ชำระราคาสินทรัพย์ดิจิทัลแทนกัน',
        a_3: 'ถูกทุกข้อ'
      },
      q_20: {
        q: 'การกระทำใดดังต่อไปนี้ กฎหมายให้สันนิษฐานว่าเป็นตัวการในการกระทำความผิด (ผู้ร่วมกระทำความผิด)',
        a_1: 'โอนหรือรับโอนสินทรัพย์ดิจิทัลระหว่างกัน',
        a_2: 'ยอมให้บุคคลอื่นใช้บัญชีซื้อขายสินทรัพย์ดิจิทัลของตน',
        a_3: 'ถูกทุกข้อ'
      }
    },
    service_form: {
      q_1: {
        q: 'ข้อใดคือลักษณะการซื้อขายแบบ Spot trading',
        a_1: 'การซื้อขายสินทรัพย์ ณ ราคาปัจจุบัน',
        a_2: 'การหยิบยืมสินทรัพย์ผู้อื่นเพื่อเพิ่มโอกาสในการทำกำไร',
        a_3: 'การทำสัญญาซื้อขายล่วงหน้า'
      },
      q_2: {
        q: 'ข้อใดคือลักษณะของการซื้อขายแบบ Margin trading',
        a_1: 'การซื้อขายสินทรัพย์ ณ ราคาปัจจุบัน',
        a_2: 'การหยิบยืมสินทรัพย์ผู้อื่นเพื่อเพิ่มโอกาสในการทำกำไร',
        a_3: 'การทำสัญญาซื้อขายล่วงหน้า'
      },
      q_3: {
        q: 'ศูนย์ซื้อขายสินทรัพย์ดิจิทัลแบบใดที่โอนสินทรัพย์ดิจิทัลผ่านทางสัญญาอัจฉริยะ (smart contract)',
        a_1: 'Centralized exchange',
        a_2: 'Decentralized Exchange',
        a_3: 'ถูกทุกข้อ'
      },
      q_4: {
        q: 'ข้อใดคือรูปแบบการซื้อขายสินทรัพย์ ณ ราคาปัจจุบัน',
        a_1: 'Spot Trading',
        a_2: 'Margin Trading',
        a_3: 'Future Trading'
      },
      q_5: {
        q: 'ข้อใดคือรูปแบบการหยิบยืมสินทรัพย์ผู้อื่นเพื่อเพิ่มโอกาสในการทำกำไร',
        a_1: 'Spot Trading',
        a_2: 'Margin Trading',
        a_3: 'Future Trading'
      },
      q_6: {
        q: 'นาย ก ต้องการซื้อบิทคอยน์ที่จำนวน 1 บิทคอยน์ ในราคาบิทคอยน์ละ 200,000 บาท และหากไม่มีผู้ขายบิทคอยน์ในราคาบิทคอยน์ละ 200,000 บาท ให้ระบบตั้งคำสั่งซื้อไว้ นาย ก ควรใช้คำสั่งซื้อขายรูปแบบใด',
        a_1: 'Good till cancel',
        a_2: 'Immediately or cancel',
        a_3: 'Fill or kill'
      },
      q_7: {
        q: 'นาย ก สร้างคำสั่งซื้อบิทคอยน์ที่จำนวน 1 บิทคอยน์ ในราคาบิทคอยน์ละ 200,000 บาท ด้วยวิธี Good till cancel และหากไม่มีผู้ขายบิทคอยน์ในราคาบิทคอยน์ละ 200,000 บาท จะมีผลอย่างไร',
        a_1: 'ระบบจะสร้างคำสั่งซื้อทิ้งไว้ในระบบ',
        a_2: 'ระบบจะทำการซื้อบิทคอยน์เท่าที่มีในราคานั้นและยกเลิกคำสั่งซื้อที่เหลือทันที',
        a_3: 'ระบบจะไม่สร้างคำสั่งซื้อใด ๆ'
      },
      q_8: {
        q: 'นาย ก สร้างคำสั่งซื้อบิทคอยน์ที่จำนวน 1 บิทคอยน์ ในราคาบิทคอยน์ละ 200,000 บาท ด้วยวิธี Immediately or cancel และหากไม่มีผู้ขายบิทคอยน์ในราคาบิทคอยน์ละ 200,000 บาท จะมีผลอย่างไร',
        a_1: 'ระบบจะสร้างคำสั่งซื้อทิ้งไว้ในระบบ',
        a_2: 'ระบบจะทำการซื้อบิทคอยน์เท่าที่มีในราคานั้นและยกเลิกคำสั่งซื้อที่เหลือทันที',
        a_3: 'ระบบจะไม่สร้างคำสั่งซื้อใด ๆ'
      },
      q_9: {
        q: 'นาย ก สร้างคำสั่งซื้อบิทคอยน์ที่จำนวน 1 บิทคอยน์ ในราคาบิทคอยน์ละ 200,000 บาท ด้วยวิธี Fill to kill และหากไม่มีผู้ขายบิทคอยน์ในราคาบิทคอยน์ละ 200,000 บาท จะมีผลอย่างไร',
        a_1: 'ระบบจะสร้างคำสั่งซื้อทิ้งไว้ในระบบ',
        a_2: 'ระบบจะทำการซื้อบิทคอยน์เท่าที่มีในราคานั้นและยกเลิกคำสั่งซื้อที่เหลือทันที',
        a_3: 'ระบบจะไม่สร้างคำสั่งซื้อใด ๆ'
      },
      q_10: {
        q: 'ข้อใดคือลักษณะของการซื้อขายด้วยคำสั่ง Limit order',
        a_1: 'การซื้อขายสินทรัพย์ในราคาที่ผู้ใช้งานระบุ',
        a_2: 'การซื้อขายสินทรัพย์โดยไม่สนใจราคาของสินทรัพย์ในขณะนั้น',
        a_3: 'เมื่อสินทรัพย์ดิจิทัลราคาเพิ่มขึ้นหรือลดลงไปถึงจุดที่ระบุไว้ ให้มีการตั้งคำสั่งซื้อขาย'
      },
      q_11: {
        q: 'ข้อใดคือลักษณะของการซื้อขายด้วยคำสั่ง Market order',
        a_1: 'การซื้อขายสินทรัพย์ในราคาที่ผู้ใช้งานระบุ',
        a_2: 'การซื้อขายสินทรัพย์โดยไม่สนใจราคาของสินทรัพย์ในขณะนั้น',
        a_3: 'เมื่อสินทรัพย์ดิจิทัลราคาเพิ่มขึ้นหรือลดลงไปถึงจุดที่ระบุไว้ ให้มีการตั้งคำสั่งซื้อขาย'
      },
      q_12: {
        q: 'ข้อใดคือลักษณะของการซื้อขายด้วยคำสั่ง Stop order',
        a_1: 'การซื้อขายสินทรัพย์ในราคาที่ผู้ใช้งานระบุ',
        a_2: 'การซื้อขายสินทรัพย์โดยไม่สนใจราคาของสินทรัพย์ในขณะนั้น',
        a_3: 'เมื่อสินทรัพย์ดิจิทัลราคาเพิ่มขึ้นหรือลดลงไปถึงจุดที่ระบุไว้ ให้มีการตั้งคำสั่งซื้อขาย'
      },
      q_13: {
        q: 'การซื้อขายสินทรัพย์ในราคาที่ผู้ใช้งานระบุคือการใช้คำสั่งซื้อแบบใด',
        a_1: 'Limit order',
        a_2: 'Market order',
        a_3: 'Stop order'
      },
      q_14: {
        q: 'การซื้อขายสินทรัพย์โดยไม่สนใจราคาของสินทรัพย์ในขณะนั้นคือการใช้คำสั่งซื้อแบบใด',
        a_1: 'Limit order',
        a_2: 'Market order',
        a_3: 'Stop order'
      },
      q_15: {
        q: 'เมื่อสินทรัพย์ดิจิทัลราคาเพิ่มขึ้นหรือลดลงไปถึงจุดที่ระบุไว้ ให้มีการตั้งคำสั่งซื้อขายคือการใช้คำสั่งซื้อแบบใด',
        a_1: 'Limit order',
        a_2: 'Market order',
        a_3: 'Stop order'
      },
      q_16: {
        q: 'เมื่อนักลุงทุนใช้บริการ margin trading ของศูนย์ซื้อขายสินทรัพย์ดิจิทัลแล้วมีผลขาดทุนจนถึงระดับที่มีความเสี่ยง ระบบจะทำการแจ้งเตือนแก่นักลงทุน การแจ้งเตือนดังกล่าวเรียกว่าอะไร',
        a_1: 'Margin call',
        a_2: 'Force sell',
        a_3: 'Leverage'
      },
      q_17: {
        q: 'ข้อใดเป็นความเสี่ยงของการซื้อขายแบบ Margin trading',
        a_1: 'ผู้ซื้อขายมีโอกาสจะถูกขโมยทรัพย์สินทรัพย์ดิจิทัล',
        a_2: 'ผู้ซื้อขายมีโอกาสขาดทุนมากกว่าปกติเมื่อเกิดความผันผวนของราคา',
        a_3: 'ถูกทุกข้อ'
      },
      q_18: {
        q: 'ข้อใดคือรูปแบบการซื้อขายที่นักลงทุนที่ขาดประสบการณ์ควรหลีกเลี่ยง',
        a_1: 'Margin trading',
        a_2: 'Spot trading',
        a_3: 'ถูกทุกข้อ'
      },
      q_19: {
        q: 'ศูนย์ซื้อขายสินทรัพย์ดิจิทัลแบบใดที่เก็บรักษาทรัพย์สินของลูกค้า',
        a_1: 'Centralized exchange',
        a_2: 'Decentralized Exchange',
        a_3: 'ถูกทุกข้อ'
      },
      q_20: {
        q: 'ศูนย์ซื้อขายสินทรัพย์ดิจิทัลแบบใดที่ผู้ใช้งานเป็นผู้เก็บรักษาสินทรัพย์ดิจิทัลด้วยตนเอง',
        a_1: 'Centralized exchange',
        a_2: 'Decentralized Exchange',
        a_3: 'ถูกทุกข้อ'
      }
    },
    market_manipulation: {
      q_1: {
        q: 'ข้อใดคือการสร้างคำสั่งเสนอซื้อหรือเสนอขายโดยไม่มีการซื้อขายจริง เพื่อให้นักลงทุนอื่นเข้าใจว่าราคาสินทรัพย์ดิจิทัลมีราคาสูงขึ้น',
        a_1: 'การตั้งคำสั่งลวง',
        a_2: 'การซื้อขายกันเอง',
        a_3: 'การลากขึ้นไปเชือด'
      },
      q_2: {
        q: 'ข้อใดคือการทำคำสั่งซื้อและคำสั่งขายที่เป็นการจับคู่ซื้อขายระหว่างกันของบุคคลหรือระหว่างกลุ่มบุคคลที่มีความเกี่ยวข้องกัน',
        a_1: 'การตั้งคำสั่งลวง',
        a_2: 'การซื้อขายกันเอง',
        a_3: 'การลากขึ้นไปเชือด'
      },
      q_3: {
        q: 'ข้อใดคือการที่บุคคลหรือกลุ่มบุคคลซื้อสินทรัพย์ดิจิทัลชนิดหนึ่งเป็นจำนวนมาก และสร้างข่าวเท็จทำให้มูลค่าสินทรัพย์ดิจิทัลชนิดนั้นพุ่งสูงขึ้น จากนั้นจึงเทขายสินทรัพย์ดิจิทัลทั้งหมดของตนเอง',
        a_1: 'การตั้งคำสั่งลวง',
        a_2: 'การซื้อขายกันเอง',
        a_3: 'การลากขึ้นไปเชือด'
      },
      q_4: {
        q: 'การซื้อขายกันเองมีความหมายตรงกับข้อใด',
        a_1: 'การสร้างคำสั่งเสนอซื้อหรือเสนอขายโดยไม่มีการซื้อขายจริง เพื่อให้นักลงทุนอื่นเข้าใจว่าราคาสินทรัพย์ดิจิทัลมีราคาสูงขึ้น',
        a_2: 'การทำคำสั่งซื้อและคำสั่งขายที่เป็นการจับคู่ซื้อขายระหว่างกันของบุคคลหรือระหว่างกลุ่มบุคคลที่มีความเกี่ยวข้องกัน',
        a_3: 'การที่บุคคลหรือกลุ่มบุคคลซื้อสินทรัพย์ดิจิทัลชนิดหนึ่งเป็นจำนวนมาก และสร้างข่าวเท็จทำให้มูลค่าสินทรัพย์ดิจิทัลชนิดนั้นพุ่งสูงขึ้น จากนั้นจึงเทขายสินทรัพย์ดิจิทัลทั้งหมดของตนเอง'
      },
      q_5: {
        q: 'การตั้งคำสั่งลวงมีความหมายตรงกับข้อใด',
        a_1: 'การสร้างคำสั่งเสนอซื้อหรือเสนอขายโดยไม่มีการซื้อขายจริง เพื่อให้นักลงทุนอื่นเข้าใจว่าราคาสินทรัพย์ดิจิทัลมีราคาสูงขึ้น',
        a_2: 'การทำคำสั่งซื้อและคำสั่งขายที่เป็นการจับคู่ซื้อขายระหว่างกันของบุคคลหรือระหว่างกลุ่มบุคคลที่มีความเกี่ยวข้องกัน',
        a_3: 'การที่บุคคลหรือกลุ่มบุคคลซื้อสินทรัพย์ดิจิทัลชนิดหนึ่งเป็นจำนวนมาก และสร้างข่าวเท็จทำให้มูลค่าสินทรัพย์ดิจิทัลชนิดนั้นพุ่งสูงขึ้น จากนั้นจึงเทขายสินทรัพย์ดิจิทัลทั้งหมดของตนเอง'
      },
      q_6: {
        q: 'การลากขึ้นไปเชือดมีความหมายตรงกับข้อใด',
        a_1: 'การสร้างคำสั่งเสนอซื้อหรือเสนอขายโดยไม่มีการซื้อขายจริง เพื่อให้นักลงทุนอื่นเข้าใจว่าราคาสินทรัพย์ดิจิทัลมีราคาสูงขึ้น',
        a_2: 'การทำคำสั่งซื้อและคำสั่งขายที่เป็นการจับคู่ซื้อขายระหว่างกันของบุคคลหรือระหว่างกลุ่มบุคคลที่มีความเกี่ยวข้องกัน',
        a_3: 'การที่บุคคลหรือกลุ่มบุคคลซื้อสินทรัพย์ดิจิทัลชนิดหนึ่งเป็นจำนวนมาก และสร้างข่าวเท็จทำให้มูลค่าสินทรัพย์ดิจิทัลชนิดนั้นพุ่งสูงขึ้น จากนั้นจึงเทขายสินทรัพย์ดิจิทัลทั้งหมดของตนเอง'
      },
      q_7: {
        q: 'ข้อใดคือการที่บุคคลชักชวนหรือโน้มน้าวให้ผู้ลงทุนซื้อขายสินทรัพย์ดิจิทัลชนิดหนึ่ง โดยมุ่งหวังให้เกิดค่าธรรมเนียมและตนได้รับส่วนแบ่งจากค่าธรรมเนียมนั้น',
        a_1: 'การสร้างปริมาณซื้อขายเพื่อหวังค่าธรรมเนียม',
        a_2: 'การใช้ข้อมูลภายใน',
        a_3: 'การปล่อยข่าวลือหรือกล่าวข้อความอันเป็นเท็จ'
      },
      q_8: {
        q: 'ข้อใดคือการที่บุคคลซึ่งอาศัยตำแหน่งหน้าที่ หรืออยู่ในฐานะที่สามารถล่วงรู้ข้อเท็จจริงที่เป็นสาระ สำคัญของสินทรัพย์ดิจิทัล และใช้ข้อมูลนั้นทำให้ตนได้รับประโยชน์ในการซื้อขายสินทรัพย์ดิจิทัล',
        a_1: 'การสร้างปริมาณซื้อขายเพื่อหวังค่าธรรมเนียม',
        a_2: 'การใช้ข้อมูลภายใน',
        a_3: 'การปล่อยข่าวลือหรือกล่าวข้อความอันเป็นเท็จ'
      },
      q_9: {
        q: 'ข้อใดคือการปล่อยข่าวลือโดยเจตนาให้ผู้อื่นสำคัญผิดในข้อเท็จจริงเกี่ยวกับสินทรัพย์ดิจิทัล หรือทำให้เข้าใจว่าสินทรัพย์ดิจิทัลใดจะมีราคาสูงขึ้นหรือลดลง',
        a_1: 'การสร้างปริมาณซื้อขายเพื่อหวังค่าธรรมเนียม',
        a_2: 'การใช้ข้อมูลภายใน',
        a_3: 'การแสดงข้อความอันเป็นเท็จ'
      },
      q_10: {
        q: 'การสร้างปริมาณซื้อขายเพื่อหวังค่าธรรมเนียมมีความหมายตรงกับข้อใด',
        a_1: 'การที่บุคคลชักชวนหรือโน้มน้าวให้ผู้ลงทุนซื้อขายสินทรัพย์ดิจิทัลชนิดหนึ่ง โดยมุ่งหวังให้เกิดค่าธรรมเนียมและตนได้รับส่วนแบ่งจากค่าธรรมเนียมนั้น',
        a_2: 'การที่บุคคลซึ่งอาศัยตำแหน่งหน้าที่ หรืออยู่ในฐานะที่สามารถล่วงรู้ข้อเท็จจริงที่เป็นสาระสำคัญของสินทรัพย์ดิจิทัล และใช้ข้อมูลนั้นทำให้ตนได้รับประโยชน์ในการซื้อขายสินทรัพย์ดิจิทัล',
        a_3: 'การปล่อยข่าวลือโดยเจตนาให้ผู้อื่นสำคัญผิดในข้อเท็จจริงเกี่ยวกับสินทรัพย์ดิจิทัล หรือทำให้เข้าใจว่าสินทรัพย์ดิจิทัลใดจะมีราคาสูงขึ้นหรือลดลง'
      },
      q_11: {
        q: 'การใช้ข้อมูลภายในมีความหมายตรงกับข้อใด',
        a_1: 'การที่บุคคลชักชวนหรือโน้มน้าวให้ผู้ลงทุนซื้อขายสินทรัพย์ดิจิทัลชนิดหนึ่ง โดยมุ่งหวังให้เกิดค่าธรรมเนียมและตนได้รับส่วนแบ่งจากค่าธรรมเนียมนั้น',
        a_2: 'การที่บุคคลซึ่งอาศัยตำแหน่งหน้าที่ หรืออยู่ในฐานะที่สามารถล่วงรู้ข้อเท็จจริงที่เป็นสาระสำคัญของสินทรัพย์ดิจิทัล และใช้ข้อมูลนั้นทำให้ตนได้รับประโยชน์ในการซื้อขายสินทรัพย์ดิจิทัล',
        a_3: 'การปล่อยข่าวลือโดยเจตนาให้ผู้อื่นสำคัญผิดในข้อเท็จจริงเกี่ยวกับสินทรัพย์ดิจิทัล หรือทำให้เข้าใจว่าสินทรัพย์ดิจิทัลใดจะมีราคาสูงขึ้นหรือลดลง'
      },
      q_12: {
        q: 'การแสดงข้อความอันเป็นเท็จมีความหมายตรงกับข้อใด',
        a_1: 'การที่บุคคลชักชวนหรือโน้มน้าวให้ผู้ลงทุนซื้อขายสินทรัพย์ดิจิทัลชนิดหนึ่ง โดยมุ่งหวังให้เกิดค่าธรรมเนียมและตนได้รับส่วนแบ่งจากค่าธรรมเนียมนั้น',
        a_2: 'การที่บุคคลซึ่งอาศัยตำแหน่งหน้าที่ หรืออยู่ในฐานะที่สามารถล่วงรู้ข้อเท็จจริงที่เป็นสาระสำคัญของสินทรัพย์ดิจิทัล และใช้ข้อมูลนั้นทำให้ตนได้รับประโยชน์ในการซื้อขายสินทรัพย์ดิจิทัล',
        a_3: 'การปล่อยข่าวลือโดยเจตนาให้ผู้อื่นสำคัญผิดในข้อเท็จจริงเกี่ยวกับสินทรัพย์ดิจิทัล หรือทำให้เข้าใจว่าสินทรัพย์ดิจิทัลใดจะมีราคาสูงขึ้นหรือลดลง'
      },
      q_13: {
        q: 'ข้อใดคือการควบคุมราคาซื้อขายโดยการซื้อสินทรัพย์ดิจิทัลจำนวนมากเพื่อกักตุน เป็นเหตุให้สินทรัพย์ดิจิทัลขาดตลาดแล้วจึงกำหนดราคาของสินทรัพย์ดิจิทัลดังกล่าวในราคาสูง',
        a_1: 'การรวมศูนย์อำนาจซื้อ',
        a_2: 'การควบคุมปริมาณสินทรัพย์ดิจิทัลในตลาดเพื่อปั่นราคา ',
        a_3: 'การใช้ข้อมูลซื้อขายของลูกค้าในลักษณะเอาเปรียบลูกค้า'
      },
      q_14: {
        q: 'ข้อใดคือการที่นายหน้าซื้อขายสินทรัพย์ดิจิทัลหรือศูนย์ซื้อขายสินทรัพย์ดิจิทัลที่รู้ข้อมูลการซื้อขายของลูกค้าแล้วไปซื้อขายสินทรัพย์ดิจิทัลตัดหน้าลูกค้า',
        a_1: 'การรวมศูนย์อำนาจซื้อ',
        a_2: 'การควบคุมปริมาณสินทรัพย์ดิจิทัลในตลาดเพื่อปั่นราคา ',
        a_3: 'การใช้ข้อมูลซื้อขายของลูกค้าในลักษณะเอาเปรียบลูกค้า'
      },
      q_15: {
        q: 'การควบคุมปริมาณสินค้าในตลาดเพื่อปั่นราคามีความหมายตรงกับข้อใด ',
        a_1: 'การมอบอำนาจให้บุคคลใดทำการซื้อขายสินทรัพย์ดิจิทัลแทน โดยผู้กระทำการแทนมีส่วนได้เสียในกำไรและขาดทุน ทำให้สามารถควบคุมอำนาจซื้อขายได้เป็นจำนวนมาก',
        a_2: 'การควบคุมราคาซื้อขายโดยการซื้อสินทรัพย์ดิจิทัลจำนวนมากเพื่อกักตุน เป็นเหตุให้สินทรัพย์ดิจิทัลขาดตลาดแล้วจึงกำหนดราคาของสินทรัพย์ดิจิทัลดังกล่าวในราคาสูง',
        a_3: 'การที่นายหน้าซื้อขายสินทรัพย์ดิจิทัลหรือศูนย์ซื้อขายสินทรัพย์ดิจิทัลที่รู้ข้อมูลการซื้อขายของลูกค้าแล้วไปซื้อขายสินทรัพย์ดิจิทัลตัดหน้าลูกค้า'
      },
      q_16: {
        q: 'การใช้ข้อมูลซื้อขายของลูกค้าในลักษณะเอาเปรียบลูกค้ามีความหมายตรงกับข้อใด',
        a_1: 'การมอบอำนาจให้บุคคลใดทำการซื้อขายสินทรัพย์ดิจิทัลแทน โดยผู้กระทำการแทนมีส่วนได้เสียในกำไรและขาดทุน ทำให้สามารถควบคุมอำนาจซื้อขายได้เป็นจำนวนมาก',
        a_2: 'การควบคุมราคาซื้อขายโดยการซื้อสินทรัพย์ดิจิทัลจำนวนมากเพื่อกักตุน เป็นเหตุให้สินทรัพย์ดิจิทัลขาดตลาดแล้วจึงกำหนดราคาของสินทรัพย์ดิจิทัลดังกล่าวในราคาสูง',
        a_3: 'การที่นายหน้าซื้อขายสินทรัพย์ดิจิทัลหรือศูนย์ซื้อขายสินทรัพย์ดิจิทัลที่รู้ข้อมูลการซื้อขายของลูกค้าแล้วไปซื้อขายสินทรัพย์ดิจิทัลตัดหน้าลูกค้า'
      },
      q_17: {
        q: 'ข้อใดคือการลวงให้นักลงทุนเชื่อว่าราคาสินทรัพย์ดิจิทัลจะปรับตัวสูงขึ้น เพื่อหวังประโยชน์ให้ตนสามารถขายสินทรัพย์ดิจิทัลได้ในราคาสูง โดยทำการตั้งคำสั่งเสนอซื้อในราคาสูงเพื่อให้นักลงทุนรายอื่นตั้งคำสั่งเสนอซื้อตาม และยกเลิกคำสั่งดังกล่าวเพื่อไปทำคำสั่งเสนอขายสินทรัพย์ดิจิทัลของตนให้นักลงทุนที่หลงเชื่อ',
        a_1: 'การดันราคาให้สูงเกินจริง',
        a_2: 'การซื้อขายโดยใช้สิทธิทางเครดิต',
        a_3: 'การดันราคาให้ต่ำเกินจริง'
      },
      q_18: {
        q: 'ข้อใดคือการสร้างข่าวลวงและโฆษณาชวนเชื่อเพื่อลดความเชื่อมั่นของนักลงทุนที่มีต่อสินทรัพย์ดิจิทัลชนิดใดชนิดหนึ่ง เป็นเหตุให้นักลงทุนเทขายสินทรัพย์ดิจิทัลนั้น',
        a_1: 'การดันราคาให้สูงเกินจริง',
        a_2: 'การซื้อขายโดยใช้สิทธิทางเครดิต',
        a_3: 'การดันราคาให้ต่ำเกินจริง'
      },
      q_19: {
        q: 'การดันราคาให้สูงเกินจริงมีความหมายตรงกับข้อใด',
        a_1: 'การลวงให้นักลงทุนเชื่อว่าราคาสินทรัพย์ดิจิทัลจะปรับตัวสูงขึ้น เพื่อหวังประโยชน์ให้ตนสามารถขายสินทรัพย์ดิจิทัลได้ในราคาสูง โดยทำการตั้งคำสั่งเสนอซื้อในราคาสูงเพื่อให้นักลงทุนรายอื่นตั้งคำสั่งเสนอซื้อตาม และยกเลิกคำสั่งดังกล่าวเพื่อไปทำคำสั่งเสนอขายสินทรัพย์ดิจิทัลของตนให้นักลงทุนที่หลงเชื่อ',
        a_2: 'การซื้อขายที่ผู้ซื้อขายสามารถทำการขายสินทรัพย์บางรายการได้ โดยที่ไม่มีสินทรัพย์ส่งมอบจริง',
        a_3: 'การสร้างข่าวลวงและโฆษณาชวนเชื่อเพื่อลดความเชื่อมั่นของนักลงทุนที่มีต่อสินทรัพย์ดิจิทัลชนิดใดชนิดหนึ่ง เป็นเหตุให้นักลงทุนเทขายสินทรัพย์ดิจิทัลนั้น'
      },
      q_20: {
        q: 'ข้อใดคือการยิงคำสั่งโดยโปรแกรมคอมพิวเตอร์ครั้งละมาก ๆ แล้วสั่งยกเลิกอย่างรวดเร็วเพื่อให้ผู้อื่นเข้าใจว่าราคาของสินทรัพย์ดิจิทัลจะมีราคาสูงขึ้นหรือต่ำลง',
        a_1: 'การตั้งคำสั่งเสนอซื้อหรือเสนอขายลวง',
        a_2: 'การเทรดตามกันจำนวนมาก',
        a_3: 'การยิงคำสั่งลวงเพื่อสอดแนม'
      }
    }
  },
  knowledge_test_v2: {
    cryptocurrency: {
      q_1: {
        q: 'คริปโทเคอร์เรนซี (Cryptocurrency) คืออะไร',
        a_1: 'หน่วยข้อมูลอิเล็กทรอนิกส์ที่สร้างขึ้นเพื่อใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้า บริการ สินทรัพย์ดิจิทัลอื่น หรือสิทธิอื่นใด โดยมีการเข้ารหัสบนระบบที่เรียกว่า “บล็อกเชน (Blockchain)”',
        a_2: 'หุ้นประเภทหนึ่งที่ออกโดยรัฐบาล',
        a_3: 'กองทุนที่ผูกกับราคาทองคำ'
      },
      q_2: {
        q: 'ข้อใดเป็นลักษณะของ Stablecoin ',
        a_1: 'คริปโทเคอร์เรนซีที่ผูกมูลค่าไว้เท่ากับสินทรัพย์อื่น',
        a_2: 'มีความผันผวนสูงมากขึ้นลงได้หลายเท่าในเวลาอันรวดเร็ว',
        a_3: 'มีมูลค่าลดลงรุนแรงตามเวลาที่กำหนด'
      },
      q_3: {
        q: 'ข้อใดเป็นความแตกต่างระหว่างคริปโทเคอร์เรนซี และทองคำ',
        a_1: 'คริปโทเคอร์เรนซี สามารถซื้อขาย แลกเปลี่ยน และสะสมเพื่อเก็งกำไรได้',
        a_2: 'คริปโทเคอร์เรนซี มีการเข้ารหัส และเก็บรักษาข้อมูลด้วยเทคโนโลยีบล็อกเชน',
        a_3: 'ทองคำมีราคาในการซื้อขายที่แปรผันตามสภาวะตลาด',
        a_4: 'ถูกทุกข้อ'
      },
      q_4: {
        q: 'ข้อใดคือความแตกต่างระหว่างคริปโตเคอร์เรนซีและสินทรัพย์แบบดั้งเดิม',
        a_1: 'คริปโตเคอร์เรนซีใช้เทคโนโลยีบล็อกเชน',
        a_2: 'สามารถซื้อขายแลกเปลี่ยนได้ผ่านตัวกลางได้ เช่น Exchange, Broker หรือ Dealer',
        a_3: 'สามารถใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้าและบริการได้ตามกฎหมายไทย',
        a_4: 'ถูกต้องทุกข้อ'
      },
      q_5: {
        q: 'ข้อใดถูกต้องเกี่ยวกับลักษณะของคริปโทเคอร์เรนซีและโทเคนดิจิทัล',
        a_1: 'คริปโทเคอร์เรนซีและโทเคนดิจิทัลมีลักษณะเป็นหน่วยข้อมูลอิเล็กทรอนิกส์หรือไม่ก็ได้',
        a_2: 'คริปโทเคอร์เรนซีถูกสร้างขึ้นเพื่อใช้สำหรับเป็นสื่อกลางในการซื้อขายแลกเปลี่ยนสินค้าหรือบริการ ในขณะที่โทเคนดิจิทัลถูกสร้างขึ้นเพื่อกำหนดสิทธิในการได้มาซึ่งสินค้าหรือบริการหรือสิทธิอื่นใดให้แก่ผู้ถือ',
        a_3: 'หลักทรัพย์ (เช่น หุ้น หุ้นกู้ เป็นต้น) ที่สร้างขึ้นบนระบบบล็อกเชน ไม่ถือว่าเป็นหลักทรัพย์ แต่อาจเป็นสินทรัพย์ดิจิทัลประเภทคริปโทเคอร์เรนซีหรือโทเคนดิจิทัลได้',
        a_4: 'Stable coin ไม่ถือเป็นคริปโทเคอร์เรนซีหรือโทเคนดิจิทัล '
      },
      q_6: {
        q: 'ข้อใดไม่ถูกต้อง',
        a_1: 'คริปโทเคอร์เรนซี กับ โทเคนดิจิทัล มีความหมายเหมือนกัน',
        a_2: 'โทเคนดิจิทัล คือ หน่วยข้อมูลอิเล็กทรอนิกส์ที่ถูกสร้างขึ้นบนระบบโดยมีวัตถุประสงค์เพื่อกำหนดสิทธิในการเข้าร่วมโครงการหรือกิจการใด หรือกำหนดสิทธิในการได้มาซึ่งสินค้าหรือบริการที่เจาะจง',
        a_3: 'คริปโทเคอร์เรนซี คือ หน่วยข้อมูลอิเล็กทรอนิกส์ที่ถูกสร้างโดยมีความประสงค์ที่จะใช้เป็นสื่อกลางในการแลกเปลี่ยนซึ่งสินค้าหรือบริการ สิทธิอื่นใด หรือแลกเปลี่ยนระหว่างสินทรัพย์ดิจิทัล',
        a_4: 'ไม่มีข้อใดถูก'
      },
      q_7: {
        q: 'ข้อใดไม่ใช่ความหมายของ Stablecoin',
        a_1: 'คริปโทเคอร์เรนซีที่อ้างอิงมูลค่าสินทรัพย์สินทรัพย์โภคภัณฑ์ เช่น ทอง หรือ น้ำมัน',
        a_2: 'คริปโทเคอร์เรนซีที่นิยมซื้อไว้เพื่อเก็งกำไร',
        a_3: 'คริปโทเคอร์เรนซีที่มีความผันผวนน้อยกว่าคริปโทเคอร์เรนซีประเภทอื่น',
        a_4: 'คริปโทเคอร์เรนซีที่มีการคงมูลค่าไว้กับสกุลเงินต่างๆ'
      },
      q_8: {
        q: 'ข้อใดคือลักษณะสำคัญของคริปโทเคอร์เรนซี',
        a_1: 'หน่วยข้อมูลอิเล็กทรอนิกส์ที่ถูกสร้างขึ้นบนระบบหรือเครือข่ายอิเล็กทรอนิกส์',
        a_2: 'มีวัตถุประสงค์เพื่อใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้า บริการ สินทรัพย์ดิจิทัลอื่นหรือสิทธิอื่นใด',
        a_3: 'ยังไม่มีการรับรองว่าสามารถใช้ชำระหนี้ได้ตามกฎหมาย',
        a_4: 'ถูกทุกข้อ'
      },
      q_9: {
        q: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับ Stablecoin',
        a_1: 'จัดเป็นหนึ่งในประเภทของคริปโทเคอร์เรนซีภายใต้กฎหมายไทย',
        a_2: 'มีกลไกการคงมูลค่าไว้กับเงินตราหรือสินทรัพย์อื่น',
        a_3: 'ราคาของสินทรัพย์ดิจิทัลประเภทนี้จะไม่ผันผวนตามอุปสงค์หรือ ความต้องการของตลาดต่างจากคริปโทเคอร์เรนซีประเภทอื่น',
        a_4: 'Bitcoin และ Ethereum เป็น Stable coin อย่างหนึ่ง '
      },
      q_10: {
        q: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับความเเตกต่างระหว่าง คริปโทเคอร์เรนซีกับโทเคนดิจิทัลและสินทรัพย์แบบดั้งเดิม',
        a_1: 'ธุรกรรมสินทรัพย์ดิจิทัลทำได้โดยไม่ต้องผ่านหน่วยงานกลาง เพราะสามารถดำเนินการและตรวจสอบโดยโปรโตคอลยืนยันร่วมกัน ทั่วทั้งเครือข่ายแทนอยู่เเล้ว',
        a_2: 'กำหนดเวลาในการซื้อขายสินทรัพย์ดิจิทัลมีตลอดเวลา 24 ชั่วโมงทั่วโลก และมีการส่งมอบแบบเรียลไทม์',
        a_3: 'ผลตอบแทนของสินทรัพย์ดิจิทัลส่วนใหญ่ไม่มีการจ่ายเงินปันผล เหมือนอย่างสินทรัพย์ดั้งเดิม',
        a_4: 'ราคาของสินทรัพย์ดิจิทัลที่จะไม่เปลี่ยนแปลงไปตามอุปสงค์ของตลาด เหมือนอย่างสินทรัพย์ดั้งเดิม'
      },
      q_11: {
        q: 'ข้อใดไม่ใช่ลักษณะของคริปโทเคอร์เรนซี (Cryptocurrency)',
        a_1: 'เป็นเงินที่ทุกธนาคารกลางใดในโลกรับรองว่าสามารถใช้ชำระหนี้ได้ตามกฎหมาย',
        a_2: 'โดยส่วนใหญ่ ถูกสร้างขึ้นโดยใช้เทคโนโลยี Blockchain สนับสนุนการแลกเปลี่ยนระหว่างผู้ใช้งาน',
        a_3: 'ไม่สามารถใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้าและบริการได้ตามกฎหมายไทย',
        a_4: 'สามารถซื้อขายแลกเปลี่ยนได้ผ่านตัวกลางได้ เช่น Exchange, Broker หรือ Dealer'
      },
      q_12: {
        q: 'ข้อใดคือความหมายของ Stable Coin',
        a_1: 'มีระบบป้องกันปิดบังตัวตนของผู้ใช้งานไม่ให้รั่วไหลออกไป',
        a_2: 'กำหนดสิทธิในการเข้าร่วมลงทุนในโครงการ',
        a_3: 'มูลค่าค่อนข้างคงที่ ราคาเคลื่อนไหวตามมูลค่าของสินทรัพย์ที่ค้ำไว้ ',
        a_4: 'เหรียญที่สร้างขึ้นเพื่อความสนุก เหรียญล้อเลียน หรือ สร้างขึ้นตามกระแส'
      },
      q_13: {
        q: 'ข้อใดกล่าวได้ถูกต้อง',
        a_1: 'Fiat Currency เช่น US Dollar สามารถใช้ชำระหนี้ได้ตามกฎหมาย',
        a_2: 'โทเคนดิจิทัลไม่สามารถใช้เพื่อแลกซื้อสินค้าในวงจำกัดได้',
        a_3: 'โทเคนดิจิทัลไม่สามารถใช้เพื่อวัตถุประสงค์ในการระดมทุนได้',
        a_4: 'คริปโทเคอร์เรนซีสามารถนำไปชำระค่าสินค้าและบริการในรูปแบบธนบัตรหรือเหรียญได้'
      },
      q_14: {
        q: 'ข้อใดต่อไปนี้กล่าวถูกต้องเกี่ยวกับลักษณะของคริปโทเคอร์เรนซี',
        a_1: 'หน่วยอิเล็กทรอนิกส์ที่สร้างขึ้นบนเครือข่ายอิเล็กทรอนิกส์เพื่อใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้าหรือบริการ',
        a_2: 'หน่วยอิเล็กทรอนิกส์ที่สร้างขึ้นบนเครือข่ายอิเล็กทรอนิกส์เพื่อกำหนดสิทธิในการได้มาซึ่งสินค้าหรือบริการ',
        a_3: 'หน่วยอิเล็กทรอนิกส์ที่สร้างขึ้นบนเครือข่ายอิเล็กทรอนิกส์เพื่อแสดงสิทธิ์ความเป็นเจ้าของในสินค้าหรือบริการ',
        a_4: 'หน่วยอิเล็กทรอนิกส์ที่สร้างขึ้นบนเครือข่ายอิเล็กทรอนิกส์เพื่อยืนยันตัวตน'
      },
      q_15: {
        q: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับ “คริปโทเคอเรนซี”',
        a_1: 'คริปโทเคอเรนซี่ จัดเป็นสินทรัพย์ที่มีความผันผวนสูง เมื่อเทียบกับการลงทุนประเภทอื่นๆ',
        a_2: '“บิทคอยน์” คือคริปโทเคอเรนซี่',
        a_3: 'คริปโทเคอเรนซี่ มีการใช้เทคโนโลยี Blockchain เป็นเบื้องหลังในการดำเนินการ',
        a_4: 'ปัจจุบันคริปโทเคอเรนซี่ สามารถใช้ชำระหนี้ตามกฏหมายของราชอาณาจักรไทยได้'
      },
      q_16: {
        q: 'คริปโทเคอร์เรนซีมีสถานะทางกฎหมายในประเทศไทยอย่างไร',
        a_1: 'เป็นสิ่งผิดกฎหมาย',
        a_2: 'สถานะเป็นสินทรัพย์ที่มีลักษณะเป็นข้อมูลอิเล็กทรอนิกส์',
        a_3: 'เป็นสกุลเงินประเภทหนึ่ง',
        a_4: 'เป็นข้อมูลทางอิเล็คทรอนิกส์'
      },
      q_17: {
        q: 'ข้อใดไม่ถูกต้อง',
        a_1: 'คริปโทเคอร์เรนซี กับ โทเคน ความหมายเหมือนกัน',
        a_2: 'โทเคน (Token) คือ หน่วยข้อมูลอิเล็กทรอนิกส์ที่ถูกสร้างขึ้น ตามจุดประสงค์ของผู้ออกโทเคน ซึ่งมีฟังก์ชันการใช้งานที่แตกต่างกันออกไป',
        a_3: 'คริปโทเคอร์เรนซี (Cryptocurrency) คือ สินทรัพย์ดิจิทัลประเภทหนึ่งที่มีการรักษาความปลอดภัยด้วยการเข้ารหัส ถูกออกแบบมาเพื่อใช้เป็นสื่อกลางในการแลกเปลี่ยนเช่นเดียวกับสกุลเงินทั่วไป',
        a_4: 'ไม่มีข้อใดถูก'
      },
      q_18: {
        q: 'ข้อใดไม่ใช่ stable coin',
        a_1: 'USDT',
        a_2: 'DAI',
        a_3: 'ETH',
        a_4: 'TUSD'
      }
    },
    blockchain: {
      q_1: {
        q: 'ข้อใดเป็นปัจจัยที่ทำให้เทคโนโลยีบล็อกเชน (Blockchain) มีความปลอดภัย',
        a_1: 'มีความโปร่งใส ง่ายต่อการตรวจสอบ',
        a_2: 'มีการเข้ารหัสข้อมูล',
        a_3: 'แก้ไขข้อมูลได้ยาก',
        a_4: 'ถูกทุกข้อ'
      },
      q_2: {
        q: 'ข้อใดถูกต้องเกี่ยวกับบล็อกเชน (Blockchain)',
        a_1: 'บล็อกเชนไม่เกี่ยวข้องกับคริปโทเคอร์เรนซี',
        a_2: 'บล็อกเชนเก็บข้อมูลแบบรวมศูนย์ (Centralized)',
        a_3: 'บล็อกเชนเป็นเทคโนโลยีที่เก็บข้อมูลธุรกรรมของคริปโทเคอร์เรนซี'
      },
      q_3: {
        q: 'Proof of Stake Consensus คืออะไร',
        a_1: 'กลไกที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องของธุรกรรมใหม่ด้วยการให้ "ผู้ตรวจสอบ (validator)" ที่ทำการถือสินทรัพย์ดิจิทัลไว้ตามจำนวนที่กำหนดไว้ และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_2: 'กลไลที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องของธุรกรรมด้วยการให้ "ผู้ตรวจสอบ หรือผู้ขุด (miner)" ทำการแก้ไขโจทย์ที่มีการเข้ารหัส (cryptographic puzzle) และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_3: 'กลไกที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องธุรกรรมโดยผู้ตรวจสอบที่ได้มีการทำการสุ่มระหว่างกันเอง และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_4: 'ไม่มีข้อใดถูกต้อง'
      },
      q_4: {
        q: 'Proof of Work Consensus คืออะไร',
        a_1: 'กลไกที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องของธุรกรรมใหม่ด้วยการให้ "ผู้ตรวจสอบ (validator)" ที่ทำการถือสินทรัพย์ดิจิทัลไว้ตามจำนวนที่กำหนดไว้ และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_2: 'กลไลที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องของธุรกรรมด้วยการให้ "ผู้ตรวจสอบ หรือผู้ขุด (miner)" ทำการแก้ไขโจทย์ที่มีการเข้ารหัส (cryptographic puzzle) และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_3: 'กลไกที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องธุรกรรมโดยผู้ตรวจสอบที่ได้มีการทำการสุ่มระหว่างกันเอง และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_4: 'ไม่มีข้อใดถูกต้อง'
      },
      q_5: {
        q: 'ข้อใดต่อไปนี้คือสิ่งที่อาจจะเกิดขึ้นในการถอนเหรียญ เมื่อกรอก Address ผู้รับผิดพลาด',
        a_1: 'เหรียญจะถูกคืนกลับสู่บัญชีล่าสุดเนื่องจากเลขหมาย Address ของผู้รับไม่ถูกต้อง',
        a_2: 'เหรียญจะถูกโอนไปยังปลายทางแต่ไม่ใช่บัญชีที่ถูกต้อง และอาจไม่สามารถกู้คืนกลับมาได้',
        a_3: 'ไม่มีอะไรเกิดขึ้นเหรียญถูกโอนไปยังปลายทางได้อย่างถูกต้อง',
        a_4: 'ไม่มีข้อใดถูก'
      },
      q_6: {
        q: 'เทคโนโลยีบล็อกเชน (Blockchain Technology) คืออะไร',
        a_1: 'เทคโนโลยีบล็อกเชนมีลักษณะการเก็บข้อมูลในแต่ละช่วงเวลาต่อกันเหมือนห่วงโซ่ที่เชื่อมต่อกันไปเรื่อยๆ โดยจะมีการสำเนาข้อมูลทั้งหมดและกระจายให้กับผู้ที่ใช้งานระบบทุกคน',
        a_2: 'เทคโนโลยีที่ไม่ต้องอาศัยคนกลาง แต่ให้ผู้ที่มีส่วนร่วมในเครือข่ายบล็อกเชนทุกคนตรวจสอบข้อมูลระหว่างกัน ทำให้การแก้ไขข้อมูลบนเทคโนโลยีบล็อกเชนเป็นไปได้ยาก หรือแทบจะเป็นไปไม่ได้',
        a_3: 'เทคโนโลยีที่สามารถพัฒนาเป็นสัญญาอัจฉริยะ (Smart Contract) เพื่อใช้ในการประมวลผลเงื่อนไขต่างๆ ในรูปแบบ If-Then เพื่อให้ธุรกรรมเสร็จสมบูรณ์ได้',
        a_4: 'ถูกทุกข้อ'
      },
      q_7: {
        q: 'ข้อใดไม่ใช่ความเสี่ยงของเทคโนโลยี Blockchain',
        a_1: 'การเชื่อมต่อระบบโครงสร้างพื้นฐานเดิมกับเครือข่าย Blockchain ที่ไม่มั่นคงเพียงพอ จะกระทบต่อการประมวลผลข้อมูลโดยรวมของระบบได้',
        a_2: 'การเปลี่ยนแปลงของข้อมูลทำให้เกิดความไม่โปร่งใสของระบบ',
        a_3: 'การเปลี่ยนแปลงของเทคโนโลยีจนเพิ่มภัยคุกคามทางไซเบอร์ได้',
        a_4: 'การเปลี่ยนแปลงทางด้านการกำกับดูแลกฎหมาย'
      },
      q_8: {
        q: 'ข้อใดคือความหมายของโหนด (Node)',
        a_1: 'บล็อกเชน (Blockchain)',
        a_2: 'คริปโทเคอร์เรนซีประเภทหนึ่ง',
        a_3: 'คอมพิวเตอร์ที่เชื่อมต่อเข้ากับเครือข่ายบล็อกเชน',
        a_4: 'ประเภทของกระเป๋าสินทรัพย์ดิจิทัล'
      },
      q_9: {
        q: 'ข้อใดไม่ใช่ลักษณะสำคัญของ Blockchain',
        a_1: 'ความไร้พรหมแดน',
        a_2: 'การปรับปรุงแก้ไขข้อมูลตามความต้องการ ของผู้ใช้งาน',
        a_3: 'ความสามารถในการเป็นเจ้าของ',
        a_4: 'การไม่สามารถเปลี่ยนแปลงแก้ไขได้'
      },
      q_10: {
        q: 'คุณลักษณะพื้นฐานของเทคโนโลยีบล็อกเชนใด ไม่เกี่ยวข้องกับกระบวนการสร้างและการซื้อขาย คริปโทเคอร์เรนซี',
        a_1: 'ความถูกต้องเที่ยงตรงของข้อมูล (Data Integrity)',
        a_2: 'ความโปร่งใสในการเข้าถึงข้อมูล (Data Transparency)',
        a_3: 'ความสามารถในการการติดตามธุรกรรม(Transaction tracsability)',
        a_4: 'ความสามารถในการระบุตัวตน (Ability of identification)'
      },
      q_11: {
        q: 'ข้อใดไม่ใช่ลักษณะหลักของเทคโนโลยีบล็อกเชน',
        a_1: 'สามารถทำธุรกรรมกันแบบ Peer-to-Peer ได้',
        a_2: 'มีการประมวลผลและจัดเก็บข้อมูลแบบกระจายศูนย์ได้',
        a_3: 'ธุรกรรมที่บันทึกบนบล็อกเชนสามารถแก้ไขได้',
        a_4: 'ฐานข้อมูลบล็อกเชนจะจัดเก็บข้อมูลในบล็อกที่เชื่อมโยงกันเป็นลูกโซ่'
      },
      q_12: {
        q: 'ข้อใดต่อไปนี้คือลักษณะของ Blockchain',
        a_1: 'เทคโนโลยีการประมวลผลและจัดเก็บข้อมูลแบบกระจายศูนย์',
        a_2: 'ข้อมูลที่ถูกบันทึกในระบบ Blockchain นั้นจะสามารถทำการแก้ไขเปลี่ยนแปลงได้ยาก',
        a_3: 'ข้อมูลมีความโปร่งใสน่าเชื่อถือ และสามารถตรวจสอบได้',
        a_4: 'ถูกทุกข้อ'
      },
      q_13: {
        q: 'ข้อใดไม่ใช่ลักษณะการเก็บข้อมูลของบล็อกเชน',
        a_1: 'การออกแบบโครงสร้างเป็น block',
        a_2: 'การกระจายสถานที่จัดเก็บข้อมูลหลายแห่ง',
        a_3: 'การเก็บข้อมูลแบบรวมศูนย์กลาง'
      },
      q_14: {
        q: 'เทคโนโลยีบล็อคเชนมีความปลอดภัยเนื่องจากมีความสม่ำเสมอจาก 3 ปัจจัยพื้นฐาน คือ การกระจายอำนาจ การเข้ารหัส และฉันทามติ ข้อความนี้เป็นจริงหรือเท็จ?',
        a_1: 'จริง',
        a_2: 'เท็จ'
      },
      q_15: {
        q: 'นักลงทุนต้องระมัดระวังและไม่ตกเป็นเหยื่อการโจมตีทางไซเบอร์ การปกป้องและรักษาความปลอดภัยของคีย์ส่วนตัวเป็นสิ่งสำคัญมาก ใครก็ตามที่มี Private key ของคุณสามารถเข้าถึงเงินทุนของคุณได้ คุณควรทำอย่างไรกับ Private key ของคุณ',
        a_1: 'สามารถเปิดเผย Private key ให้ทุกคนได้เห็น',
        a_2: 'สามารถแบ่งบัน Private key ให้กับเพื่อน',
        a_3: 'เก็บรักษา Private key เป็นความลับ',
        a_4: 'ควรทำสำเนาดิจิทัลของ Private key และจัดเก็บไว้ทางออนไลน์'
      },
      q_16: {
        q: 'จุดเด่นของ Blockchain คืออะไรบ้าง',
        a_1: 'เพิ่มความน่าเชื่อของการจัดเก็บข้อมูล',
        a_2: 'ไม่สามารถเปลี่ยนแปลงและแก้ไขข้อมูลได้',
        a_3: 'ไม่ใช้ตัวกลางในการจัดเก็บข้อมูลและการตรวจสอบ',
        a_4: 'ถูกทุกข้อ'
      },
      q_17: {
        q: 'ข้อใด คือ Blockchain splits?',
        a_1: 'A split',
        a_2: 'A division',
        a_3: 'A sidechain',
        a_4: 'A fork'
      },
      q_18: {
        q: 'อะไร คือ Public Blockchain?',
        a_1: 'เป็น digital ledger ที่ข้อมูลถูกเก็บไว้ในเครือข่ายของคอมพิวเตอร์แต่ละเครื่องอย่างอิสระ',
        a_2: 'เป็น digital ledger ที่ถูกสร้างและจัดการโดยบริษัทแต่เผยแพร่สู่สาธารณะได้',
        a_3: 'เป็นแพลตฟอร์มที่ได้รับการอำนวยความสะดวกจากภาครัฐในการแลกเปลี่ยนเงินตรา',
        a_4: 'เป็นคอมพิวเตอร์ประเภทหนึ่งที่ถูกสร้างขึ้นเพื่อขุดเหรียญบิทคอยน์'
      },
      q_19: {
        q: 'ข้อใดคือคุณสมบัติของ Blockchain What is/are properties of Blockchain?',
        a_1: 'การกระจายศูนย์ (decentralized)',
        a_2: 'การไม่สามารถเปลี่ยนแปลงแก้ไขได้ (immutable)',
        a_3: 'ฉันทามติ (consensus)',
        a_4: 'ถูกทุกข้อ (All of the above)'
      },
      q_20: {
        q: 'ข้อใดถูกต้องเกี่ยวกับ Smart contract',
        a_1: 'เทคโนโลยี NFT ไม่จำเป็นจะต้องอาศัยการทำงานของ Smart contract',
        a_2: 'โปรแกรมที่จัดเก็บไว้ในระบบบล็อกเชนที่ทำงานโดยอัตโนมัติเมื่อตรงตามเงื่อนไขที่กำหนดไว้ล่วงหน้า ซึ่งจะเรียกใช้การตรวจสอบเงื่อนไขและตรรกะ เพื่อให้ธุรกรรมเสร็จสมบูรณ์ได้อย่างมั่นใจ',
        a_3: 'Smart contract สามารถแก้ไขธุรกรรมในอดีตได้',
        a_4: 'ถูกทุกข้อ'
      }
    },
    cryptocurrency_wallet: {
      q_1: {
        q: 'จะเกิดอะไรขึ้นเมื่อคุณส่งสินทรัพย์ดิจิตอลไปที่ wallet address ผิด?',
        a_1: 'สินทรัพย์ดิจิทัลจะคืนกลับมาที่กระเป๋าดิจิทัลของเราเอง',
        a_2: 'สินทรัพย์ดิจิทัลนั้นจะหายไปอย่างถาวร'
      },
      q_2: {
        q: 'ข้อใดต่อไปนี้คือสิ่งที่อาจจะเกิดขึ้นในการถอนเหรียญ เมื่อกรอก Address ผู้รับผิดพลาด',
        a_1: 'เหรียญจะถูกคืนกลับสู่บัญชีล่าสุดเนื่องจากเลขหมาย Address ของผู้รับไม่ถูกต้อง',
        a_2: 'เหรียญจะถูกโอนไปยังปลายทางแต่ไม่ใช่บัญชีที่ถูกต้อง',
        a_3: 'ไม่มีอะไรเกิดขึ้นเหรียญถูกโอนไปยังปลายทางได้อย่างถูกต้อง',
        a_4: 'ข้อ A และ B ถูกต้อง'
      },
      q_3: {
        q: 'ข้อใดคือความเสี่ยงที่อาจเกิดขึ้นได้จากการใช้บริการ “คริปโทเคอเรนซี” ผ่านแพลทฟอร์มการแลกเปลี่ยน (Cryptocurrency Exchange)',
        a_1: 'ทางผู้ให้บริการ (Cryptocurrency Exchange) จะเป็นผู้เก็บ Private Key ไว้',
        a_2: 'ระบบการทำงานของแพลทฟอร์มเกิดการผิดพลาดทำให้ไม่สามารถตั้งคำสั่งซื้อ-ขายได้',
        a_3: 'คริปโทเคอเรนซี่ในบัญชีสูญหายอันเนื่องจากผู้ให้บริการ (Cryptocurrency Exchange) ถูกโจมตีจากกลุ่มผู้ไม่หวังดี',
        a_4: 'ถูกทุกข้อ'
      },
      q_4: {
        q: 'ข้อใดถูกต้องเกี่ยวกับกระเป๋าสินทรัพย์ดิจิทัล (Digital Asset Wallet)',
        a_1: 'ใช้ในการเก็บสินทรัพย์ดิจิทัลก่อนนำไปใช้งานในรูปแบบต่าง ๆ',
        a_2: 'ใช้ในการคำนวณราคาสินทรัพย์ดิจิทัล',
        a_3: 'ไม่ควรใช้ เพราะความปลอดภัยต่ำ'
      },
      q_5: {
        q: 'ข้อใดที่ทำให้คุณโอนคริปโทเคอร์เรนซีไปยังผู้รับปลายทางได้สำเร็จ',
        a_1: 'ตรวจสอบที่อยู่กระเป๋าสินทรัพย์ดิจิทัลของแพลตฟอร์มปลายทาง ทุกครั้ง',
        a_2: 'ศึกษาทำความเข้าใจวิธีการโอน หรือสอบถามเจ้าหน้าที่เพื่อขอคำแนะนำ',
        a_3: 'ถูกทุกข้อ'
      },
      q_6: {
        q: 'นักลงทุนสามารถเก็บคริปโทเคอร์เรนซีและโทเคนดิจิทัลไว้ที่ใด',
        a_1: 'บัญชีธนาคาร (Bank Account)',
        a_2: 'กระเป๋าสินทรัพย์ดิจิทัลที่เชื่อมต่อกับเครือข่ายตลอดเวลา (Hot Wallet)',
        a_3: 'กระเป๋าสินทรัพย์ดิจิทัลที่เชื่อมต่อกับเครือข่ายเมื่อทำธุรกรรมเท่านั้น (Cold Wallet)',
        a_4: 'ถูกทั้ง ข.และ ค.'
      },
      q_7: {
        q: 'ข้อใดไม่ถูกต้องเกี่ยวกับ Hot Wallet และ Cold Wallet',
        a_1: 'ผู้ประกอบธุรกิจสินทรัพย์ดิจิทัลในประเทศไทยจะต้องจัดเก็บสินทรัพย์ดิจิทัลของลูกค้าส่วนใหญ่ไว้ใน Cold wallet หรือนำไปฝากไว้กับ Digital Asset Custody',
        a_2: 'การใช้งาน Cold Wallet มีความปลอดภัยจากการถูกโจรกรรมทางไซเบอร์มากกว่าการใช้งาน Hot Wallet',
        a_3: 'หาก private key ของ Hot Wallet และ Cold Wallet ของผู้ลงทุน ถูกเข้าถึงหรือถูกเปิดเผยให้กับบุคคลที่ไม่มีส่วนเกี่ยวข้อง ควรรีบย้ายสินทรัพย์ดิจิทัลออกจาก Hot Wallet และ Cold Wallet ไปเก็บไว้ที่อื่นทันที',
        a_4: 'ผู้ลงทุนควรจัดเก็บ private key ไว้กับผู้ให้บริการ cloud '
      },
      q_8: {
        q: 'ข้อใดคือวิธีการเก็บรักษากระเป๋าสินทรัพย์ดิจิทัลให้ปลอดภัย',
        a_1: 'เก็บสินทรัพย์ดิจิทัลที่ใช้จ่ายไว้ในกระเป๋าออนไลน์ (Hot Wallet) และเก็บสินทรัพย์ดิจิทัลที่เหลือไว้ในกระเป๋าออฟไลน์ (Cold Wallet)',
        a_2: 'มีกระเป๋าเงินสำรอง กรณีกระเป๋าเงินเสียหายหรือถูกขโมย',
        a_3: 'งดเชื่อมต่อ WiFi สาธารณะ',
        a_4: 'ถูกทุกข้อ'
      },
      q_9: {
        q: 'ข้อใดคือข้อดีของการฝากสินทรัพย์ดิจิทัลของลูกค้า ไว้ในกระเป๋าสินทรัพย์ดิจิทัลของผู้ประกอบธุรกิจ (custodial wallet)',
        a_1: 'ผู้ให้บริการก็จะมีระบบการจัดเก็บให้ จึงไม่ต้องกังวลว่าจะทำ private key สูญหาย',
        a_2: 'ลูกค้าทำธุรกรรมได้สะดวกมากขึ้น',
        a_3: 'ถูกทุกข้อ'
      },
      q_10: {
        q: 'ข้อใดกล่าวถูกต้องเกี่ยวกับประเภทและการใช้งานของสินทรัพย์ดิจิทัล',
        a_1: 'Hardware wallet เป็น custodial wallet มีลักษณะเป็นอุปกรณ์ (device) โดย private key จะถูกเก็บไว้ในอุปกรณ์ในลักษณะ offline ทำให้มีความปลอดภัยสูง จากการโจรกรรมทางไซเบอร์',
        a_2: 'Paper wallet เป็น non-custodial wallet ผู้ใช้งานจะสร้าง wallet จากเว็บไซต์ แล้วจดหรือพิมพ์ private key เก็บไว้บนกระดาษแต่ก็มีความเสี่ยงที่หมึกจะจางหรือกระดาษสูญหายได้',
        a_3: 'desktop / mobile wallet เป็น non-custodial wallet เป็นการการติดตั้งโปรแกรม wallet ไว้ที่คอมพิวเตอร์หรือโทรศัพท์มือถือ โดยเก็บ private key ที่เข้ารหัสแล้วบนอุปกรณ์ดังกล่าว ความปลอดภัยจะขึ้นอยู่กับระดับการรักษาความปลอดภัยของอุปกรณ์นั้น ๆ',
        a_4: 'ข้อ B และ ข้อ C กล่าวถูกต้อง'
      },
      q_11: {
        q: 'ข้อใดกล่าวถูกต้องเกี่ยวกับการฝากสินทรัพย์ดิจิทัลของลูกค้าไว้ในกระเป๋าสินทรัพย์ดิจิทัลของผู้ประกอบธุรกิจ',
        a_1: 'มีการแบ่งแยกบัญชีทรัพย์สินลูกค้าออกจากทรัพย์สินของผู้ประกอบการ',
        a_2: 'ลูกค้าสามารถส่งคำสั่งโอนสินทรัพย์ดิจิทัลออกจากกระเป๋าของผู้ประกอบการได้ด้วยตนเอง',
        a_3: 'เก็บทรัพย์สินลูกค้าส่วนใหญ่ไว้กับผู้รับฝากสินทรัพย์ดิจิทัล',
        a_4: 'ถูกต้องทุกข้อ'
      },
      q_12: {
        q: 'ข้อใดคือประโยชน์ของกระเป๋าสินทรัพย์ดิจิทัล (Wallet)',
        a_1: 'ใช้เก็บรักษาธนบัตร',
        a_2: 'ใช้เก็บรักษาตราสารทางการเงิน',
        a_3: 'ใช้เก็บรักษาสินทรัพย์ดิจิทัล',
        a_4: 'ใช้เก็บรักษาทองคำแท่ง'
      },
      q_13: {
        q: 'ข้อใดต่อไปนี้ไม่ใช่กระเป๋าสินทรัพย์ดิจิทัล (Wallet) ที่ใช้เก็บรักษาสินทรัพย์ดิจิทัล',
        a_1: 'Hot Wallet',
        a_2: 'Cold Wallet / Storage',
        a_3: 'Hardware Wallet',
        a_4: 'บัญชีธนาคาร'
      },
      q_14: {
        q: 'นาย ก จัดเก็บสินทรัพย์ดิจิทัลด้วยตนเองโดยใช้ Hardware wallet (Trezor) หากนาย ก ทำ Trezor หาย นาย ก จะกู้ Private key ได้อย่างไร',
        a_1: 'แจ้งคณะกรรมการ ก.ล.ต.',
        a_2: 'ใช้ seed ที่สำรองไว้',
        a_3: 'ไม่สามารถกู้รหัสผ่านคืนได้'
      },
      q_15: {
        q: 'นักลงทุนสามารถใช้สิ่งใดในการตรวจสอบผลการทำธุรกรรม',
        a_1: 'Address',
        a_2: 'Transaction ID',
        a_3: 'ถูกทุกข้อ'
      },
      q_16: {
        q: 'ข้อใดคือประเภทของ Stablecoin',
        a_1: 'Fiat-Backed Stablecoin',
        a_2: 'Crypto-Backed Stablecoin',
        a_3: 'Algorithmic Stablecoin',
        a_4: 'ทุกข้อที่กล่าวมาคือประเภทของ Stablecoin '
      },
      q_17: {
        q: 'ธุรกรรมของสินทรัพย์ดิจิทัลสามารถตรวจสอบได้โดยการใช้ transaction ID หรือ Wallet address',
        a_1: 'จริง',
        a_2: 'เท็จ'
      },
      q_18: {
        q: 'คุณซื้อ Hardwere Wallet เพื่อเก็บ Bitcoin โดยตรงจากผู้ผลิต โดยได้ทำการตั้งค่าและเขียนคำกู้คืน 12 คำลงบนกระดาษ เมื่อคุณโอน Bitcoin ไปยัง Wallet Addressและกดยืนยัน ต่อมา Hardwere Wallet ดังกล่าวถูกทำลาย และได้ทำคำกู้คืนหาย คุณจะสามารถกู้คืน Bitcoin ได้อย่างไร',
        a_1: 'Bitcoin ไม่สามารถกู้คืนได้',
        a_2: 'สามารถกู้คืนได้โดยผู้ผลิต Bitcoin',
        a_3: 'สามารถกู้คืนได้โดยศูนย์ซื้อขายสินทรัพย์ดิจิทัล',
        a_4: 'สามารถกู้คืนได้โดยกลต'
      },
      q_19: {
        q: 'ข้อใดเป็นสิ่งที่ต้องพึงระวังสำหรับมือใหม่เกี่ยวกับเรื่องของ Wallet',
        a_1: 'Crypto Wallet ปลอม',
        a_2: 'ห้ามถ่ายรูป Seed Phrase เก็บไว้ใน PC, Smart Phone ฯลฯ',
        a_3: 'ตรวจสอบปลายทางในการโอนสินทรัพย์ดิจิทัลทุกครั้งอย่างระมัดระวัง',
        a_4: 'ถูกทุกข้อที่กล่าวมา'
      },
      q_20: {
        q: 'ข้อใดคือการเก็บรักษาสินทรัพย์ดิจิทัลที่ “ไม่ควร” ทำเป็นอย่างยิ่ง',
        a_1: 'เก็บสินทรัพย์ดิจิทัลไว้ใน Hardware Wallet ด้วยตนเอง',
        a_2: 'ฝากให้เพื่อนเก็บสินทรัพย์ดิจิทัล เพราะเพื่อนมีความรู้มากกว่าและเรารู้จักเพื่อนมานาน',
        a_3: 'เก็บสินทรัพย์ดิจิทัลไว้กับ Exchange',
        a_4: 'กระจายความเสี่ยงในการเก็บสินทรัพย์ดิจิทัลทั้งใน Hardware Wallet และ Exchange ตามวัตถุประสงค์ในการลงทุน'
      },
      q_21: {
        q: 'อะไรคือ cold storage?',
        a_1: 'กระเป๋าสินทรัพย์ดิจิทัลที่อาจอยู่ในรูปแบบของคอมพิวเตอร์ตั้งโต๊ะ',
        a_2: 'การเก็บเอกสารที่ไม่ได้อยู่บนเครื่องมืออิเล็กทรอนิกส์',
        a_3: 'Private Key ที่ไม่ได้ต่อกับอินเตอร์เน็ต',
        a_4: 'ถูกทุกข้อ'
      },
      q_22: {
        q: 'Custodial wallet คืออะไร',
        a_1: 'การให้บริการกระเป๋าเก็บสินทรัพย์ดิจิทัลที่มีการรับฝากสินทรัพย์ดิจิทัลของ ผู้ใช้งานหรือลูกค้าด้วย โดยผู้ให้บริการ custodial wallet จะเป็นผู้เก็บรักษา private key',
        a_2: 'กระเป๋าเก็บสินทรัพย์ดิจิทัลที่ผู้ให้บริการเป็นเพียงผู้พัฒนาโปรแกรมหรือ แอปพลิเคชัน โดยไม่ได้ทำหน้าที่เก็บรักษา private key ให้แก่ผู้ใช้งาน',
        a_3: 'ชื่อของบริษัทที่พัฒนา wallet',
        a_4: 'ถูกต้องทุกข้อ'
      },
      q_23: {
        q: 'ข้อใดไม่ถูกต้องเกี่ยวกับวิธีการจัดเก็บ Private Key และสินทรัพย์ดิจิทัลให้ปลอดภัย',
        a_1: 'จัดเก็บรหัส Private key ไว้บนระบบ cloud และ ทำสำเนาไว้ในคอมพิวเตอร์',
        a_2: 'จัดเก็บรหัส Private key ไว้ในรูปแบบ กระดาษ และจัดเก็บไว้ภายในตู้นิรภัย',
        a_3: 'เลือกใช้งาน Hardware Wallet และจัดเก็บไว้ภายในตู้นิรภัย',
        a_4: 'ไม่มีข้อใดถูก'
      },
      q_24: {
        q: 'Private Key สำคัญอย่างไร',
        a_1: 'ทำหน้าที่เหมือนรหัสลับ (password  เพื่อเข้าถึงสินทรัพย์ดิจิทัลใน Wallet)',
        a_2: 'ทำหน้าที่เหมือน Email address สามารถส่งให้ผู้อื่นได้',
        a_3: 'ถ้า Private Key หายสามารถสร้างใหม่ได้อย่างง่ายดาย',
        a_4: 'ถูกทุกข้อ'
      }
    },
    investment: {
      q_1: {
        q: 'ข้อใดถูกต้องเกี่ยวกับภาพรวมของตลาดคริปโทเคอร์เรนซี',
        a_1: 'ตลาดคริปโทเคอร์เรนซีมีความผันผวนมากกว่าตลาดหุ้น',
        a_2: 'ตลาดคริปโทเคอร์เรนซีมีความผันผวนน้อยกว่าตลาดหุ้น',
        a_3: 'ตลาดคริปโทเคอร์เรนซีไม่มีความผันผวน'
      },
      q_2: {
        q: 'ข้อใดเป็นปัจจัยที่มีผลต่อราคาการซื้อขายคริปโทเคอร์เรนซี',
        a_1: 'ข่าวสารที่เกี่ยวข้องกับคริปโทเคอร์เรนซีดังกล่าว',
        a_2: 'สถานการณ์ที่ส่งผลต่อสภาวะตลาดโลก',
        a_3: 'ถูกทุกข้อ'
      },
      q_3: {
        q: 'ข้อใดไม่ใช่ปัจจัยในการประเมินมูลค่าพื้นฐานของสินทรัพย์ดิจิทัล',
        a_1: 'ปริมาณของเหรียญว่ามีอยู่อย่างจำกัดหรือสามารถสร้างเพิ่มขึ้นได้',
        a_2: 'สัญญาอัจฉริยะ (Smart Contract) ที่ใช้กับสินทรัพย์ดิจิทัลควรได้รับการตรวจสอบโดยผู้ตรวจสอบที่น่าเชื่อถือ',
        a_3: 'รูปแบบในการนำสินทรัพย์ดิจิทัลไปใช้ประโยชน์หรือสิทธิต่างๆ เช่น เพื่อระบบการเงินแบบไม่รวมศูนย์ เพื่อสนับสนุนอำนาจในการโหวต ผลประโยชน์ตอบแทนที่ได้รับจากการถือสินทรัพย์ดิจิทัล เป็นต้น',
        a_4: 'ความผันผวนของราคา'
      },
      q_4: {
        q: 'ข้อใดต่อไปนี้เป็นการสร้างพอร์ตการลงทุนที่สัมพันธ์กับความเสี่ยงที่ยอมรับได้',
        a_1: 'รับความสูญเสียได้ 10% ของเงินลงทุนทั้งหมด : ลงทุนในคริปโทเคอร์เรนซี 10%',
        a_2: 'รับความสูญเสียได้ 50% ของเงินลงทุนทั้งหมด : ลงทุนในคริปโทเคอร์เรนซี 50%',
        a_3: 'รับความสูญเสียได้ 100% ของเงินลงทุนทั้งหมด : ลงทุนในคริปโทเคอร์เรนซี 100%',
        a_4: 'ถูกทุกข้อ'
      },
      q_5: {
        q: 'ข้อใดคือลักษณะของตลาดสินทรัพย์ดิจิทัล',
        a_1: 'เป็นตลาดที่มีความผันผวนสูง',
        a_2: 'ยังไม่ถูกกฎหมายในบางประเทศ',
        a_3: 'เป็นตลาดที่สามารถซื้อขายได้ 24 ชั่วโมงต่อวัน',
        a_4: 'ถูกทุกข้อ'
      },
      q_6: {
        q: 'ข้อใดกล่าวถูกต้องเกี่ยวกับสภาวะตลาด คริปโทเคอร์เรนซีที่มีผลกระทบต่อการลงทุน',
        a_1: 'แนวโน้มของตลาดจะผลักดันให้ทุกอุตสาหกรรมต้องเข้ามาอยู่ในรูปแบบดิจิทัล (Digitalization)',
        a_2: 'แม้ว่าตลาดคริปโทเคอร์เรนซีจะมีความผันผวนสูงเป็นปกติ แต่จำนวนของผู้ลงทุนหน้าใหม่ๆ ก็เพิ่มมากขึ้นเรื่อยๆ ในช่วงหลายปีที่ผ่านมา',
        a_3: 'โซเชียลมีเดียถือเป็นเครื่องมือวิเคราะห์สภาวะตลาดที่สำคัญอย่างหนึ่งสำหรับนักลงทุนคริปโทเคอร์เรนซีมือใหม่',
        a_4: 'ถูกทุกข้อ'
      },
      q_7: {
        q: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับความผันผวน ของราคาคริปโทเคอร์เรนซี',
        a_1: 'ตลาดคริปโทเคอร์เรนซีมีความผันผวนน้อยกว่าตลาดหุ้น',
        a_2: 'ข่าวสารและทวิตเตอร์คนดังมีผลต่อการขึ้นหรือลงของราคาคริปโทเคอร์เรนซี',
        a_3: 'เสถียรภาพทางเศรษฐกิจมีผลต่อความผันผวนของราคาคริปโทเคอร์เรนซี',
        a_4: 'ความผันผวนของราคาส่งผลกระทบต่อเนื่องไปยังความน่าเชื่อถือของเงินสกุลดิจิทัล หากมีความน่าเชื่อถือในระดับต่ำ ความเสี่ยงก็จะสูง และส่งผลต่อการตัดสินใจลงทุนในคริปโทเคอร์เรนซี'
      },
      q_8: {
        q: 'ข้อใดไม่ใช่สิ่งที่ควรปฏิบัติในการกระจายความเสี่ยงและวางกลยุทธ์ในการลงทุน',
        a_1: 'ลงทุนในความเสี่ยงที่เหมาะสมกับความเสี่ยงที่ยอมรับได้',
        a_2: 'หมั่นติดตามบัญชีซื้อขายคริปโทเคอร์เรนซีอยู่เสมอ',
        a_3: 'ทำการศึกษาหาข้อมูลให้ครบถ้วนก่อนตัดสินใจลงทุน เพื่อให้เข้าใจลักษณะความเสี่ยงและ ผลตอบแทนของสินทรัพย์แต่ละประเภท',
        a_4: 'ควรลงทุนโดยให้น้ำหนักการลงทุนในสินทรัพย์ดิจิทัลเพียงอย่างเดียว'
      },
      q_9: {
        q: 'ข้อใดกล่าวไม่ถูกต้อง',
        a_1: 'ระมัดระวังและตรวจสอบความถูกต้องในการโอนสินทรัพย์ดิจิทัลทุกครั้งเพื่อป้องกันการสูญหาย',
        a_2: 'คริปโทเคอร์เรนซีมีมูลค่าค่อนข้างคงที่ ดังนั้น นักลงทุนที่รับความเสี่ยงได้ต่ำควรมีสัดส่วนการลงทุนในคริบโตเคอร์เรนซีมากกว่าสินทรัพย์ประเภทอื่น',
        a_3: 'ราคาและปริมาณการซื้อขายของคริปโทเคอร์เรนซี ขึ้นกับปัจจัยต่างๆ เช่น Demand และ Supply ในขณะนั้น ข่าวสารจากผู้พัฒนาplatform หรือ จาก Influencer ผ่าน Social Media ต่างๆ',
        a_4: 'ผู้ลงทุนควรศึกษาหาข้อมูล มีการกระจายความเสี่ยงและมีกลยุทธ์การลงทุนให้เหมาะสมกับผลประเมินความเสี่ยงของตนเอง (Suitability Test)'
      },
      q_10: {
        q: 'ข้อใดถูกต้องที่สุดเกี่ยวกับแนวทางการคำนวณมูลค่าพื้นฐานของคริปโทเคอร์เรนซี',
        a_1: 'ประเมินมูลค่าตลาดของสกุลเงินคริปโทเคอร์เรนซีกับมูลค่าของทองคำ',
        a_2: 'ประเมินมูลค่าด้วยวิธีเดียวกับสกุลเงินทั่วไปโดยประเมินจากปริมาณและรอบหมุนของเงินในระบบ',
        a_3: 'ประเมินมูลค่าของคริปโทเคอร์เรนซีเป็นเสมือนสินค้า และผลิตภัณฑ์ โดยคำนวณจากต้นทุนการผลิต',
        a_4: 'การประเมินมูลค่าพื้นฐานของคริปโทเคอร์เรนซีส่วนใหญ่ยังเป็นเรื่องใหม่ และยังไม่มีทฤษฎีที่แน่นอนรองรับ'
      },
      q_11: {
        q: 'ข้อใดอธิบายตลาดซื้อขายสินทรัพย์ดิจิทัลได้อย่างถูกต้อง',
        a_1: 'เปิดให้บริการซื้อขาย 24 ชั่วโมง',
        a_2: 'สินทรัพย์ที่ซื้อขายจะอยู่ในรูปของคริปโทเคอร์เรนซีและโทเคนดิจิทัล',
        a_3: 'ความเสี่ยงและความผันผวนของราคาของแต่ละสกุลเงินดิจิทัล / โทเคนดิจิทัลอาจแตกต่างกันไปตามเศรษฐศาสตร์พื้นฐาน',
        a_4: 'ถูกทุกข้อ'
      },
      q_12: {
        q: 'ข้อใดไม่ใช่ข้อควรปฏิบัติก่อนตัดสินใจลงทุนในคริปโทเคอร์เรนซี',
        a_1: 'ลงทุนตามคำแนะนำของผู้เชี่ยวชาญ',
        a_2: 'ศึกษาข้อมูลของเหรียญก่อนการลงทุนอย่างละเอียด',
        a_3: 'ศึกษา white paper ของเหรียญก่อนตัดสินใจลงทุน',
        a_4: 'ประเมินความเสี่ยงของตัวเองก่อนการลงทุน'
      },
      q_13: {
        q: 'ข้อใดกล่าวถูกต้องที่สุดเกี่ยวกับลักษณะความเสี่ยงของการลงทุนในสินทรัพย์ดิจิทัล',
        a_1: 'มีความเสี่ยงต่ำ และให้ผลตอบแทนต่ำ',
        a_2: 'ราคาซื้อขายมีความผันผวนสูง สามารถสูญเสียเงินลงทุนทั้งหมดได้ในเวลาอันรวดเร็ว',
        a_3: 'มีความเสี่ยงปานกลาง และให้ผลตอบแทนสูง',
        a_4: 'ความเสี่ยงและความผันผวนของแต่ละสินทรัพย์พิจิทัลจะแตกต่างกันไปตามปัจจัยพื้นฐานทางธุรกิจและเศรษฐศาตร์ที่สินทรัพย์ดิจิทัลมีการอ้างอิง'
      },
      q_14: {
        q: 'ข้อใดกล่าวไม่ถูกต้อง ในการประเมินความเสี่ยงหากพบ เหรียญ หรือ โทเคน ราคาสูงขึ้นอย่างผิดปกติ ก่อนที่จะเริ่มทำการซื้อ-ขาย',
        a_1: 'เทียบราคาของ เหรียญ หรือ โทเคน นั้นๆ กับผู้ให้บริการรายอื่นๆ ก่อนทำการส่งคำสั่งซื้อ-ขาย',
        a_2: 'ติดต่อผู้ให้บริการเพื่อตรวจสอบว่า เหรียญ หรือ โทเคน ราคาสูงขึ้นอย่างผิดปกติ จริงหรือไม่',
        a_3: 'หาโอกาสทำกำไรในทันที',
        a_4: 'ยกเลิกคำสั่งซื้อ - ขาย ที่ตั้งไว้ทันทีเพื่อป้องกันการ Match Order ที่ไม่พึงประสงค์'
      },
      q_15: {
        q: 'คริปโทเคอเรนซีจัดอยู่ในกลุ่มสินทรัพย์ที่มีความเสี่ยงระดับใด',
        a_1: 'เสี่ยงสูง',
        a_2: 'เสี่ยงกลาง',
        a_3: 'เสี่ยงต่ำ',
        a_4: 'ไม่มีความเสี่ยงใดๆ'
      },
      q_16: {
        q: 'ข้อใดต่อไปนี้ถูกต้องเกี่ยวกับ การเตรียมตัวในการเริ่ม ซื้อ-ขาย “คริปโทเคอเรนซี”',
        a_1: 'ตรวจสอบความเสี่ยงที่ยอมรับได้ของตนเองในราคาที่ผันผวนสูงของคริปโทเคอเรนซี',
        a_2: 'เลือกใช้บริการผู้ให้บริการแพลทฟอร์มที่ได้รับการรับรองจากหน่วยงานของรัฐฯ',
        a_3: 'ศึกษาข้อมูลของ คริปโทเคอเรนซี แต่ละสกุลอย่างละเอียดก่อนทำการซื้อ - ขาย',
        a_4: 'ถูกทั้ง 3 ข้อ'
      },
      q_17: {
        q: 'ข้อใดคือรูปแบบการซื้อขายที่นักลงทุนที่ขาดประสบการณ์ควรหลีกเลี่ยง',
        a_1: 'Margin trading',
        a_2: 'Spot trading',
        a_3: 'Holding',
        a_4: 'ถูกทุกข้อ'
      },
      q_18: {
        q: 'ข้อใดที่ “ไม่ควร” ทำเป็นอย่างยิ่งในการลงทุนในสินทรัพย์ดิจิทัล',
        a_1: 'ศึกษาหาข้อมูลเกี่ยวกับสินทรัพย์ดิจิทัลให้ครบถ้วนและติดตามข่าวสารอยู่เสมอ',
        a_2: 'กระจายความเสี่ยงอย่างเหมาะสมและแบ่งน้ำหนักการลงทุนในสินทรัพย์ดิจิทัลตามความเสี่ยงที่เรายอมรับได้เท่านั้น',
        a_3: 'All In ในเหรียญที่มีอนาคตและคิดเอาเองว่าจะเติบโตมาก ๆ เพราะโอกาสสร้างตัวไม่ได้มีมาบ่อย ๆ',
        a_4: 'ถูกทุกข้อที่กล่าวมา'
      },
      q_19: {
        q: 'ปัจจัยใดอาจจะส่งผลให้ราคาสินทรัพย์ดิจิทัลปรับตัวลดลงได้',
        a_1: 'ความนิยมและความต้องการสินทรัพย์ดิจิทัลที่เพิ่มสูงในอนาคต (Demand เพิ่มมากขึ้น)',
        a_2: 'นักลงทุนรายใหญ่และกองทุนขนาดใหญ่ ต้องการซื้อสินทรัพย์ดิจิทัลเพราะอยากกระจายพอร์ตการลงทุนให้หลากหลาย (Asset Allocation)',
        a_3: 'ธนาคารกลางสหรัฐ ฯ (FED)  ทำ Quantitative Tightening (QT) คือการดึงสภาพคล่องออกจากระบบการเงิน ทำให้สินทรัพย์เสี่ยงทั่วโลกปรับตัวลง รวมถึงสินทรัพย์ดิจิทัล',
        a_4: 'ไม่มีข้อใดที่ถูกต้อง'
      },
      q_20: {
        q: 'ข้อใดไม่ใช่ข้อควรปฏิบัติก่อนตัดสินใจลงทุนในคริปโทเคอร์เรนซี',
        a_1: 'ลงทุนตามคำแนะนำของผู้เชี่ยวชาญ',
        a_2: 'ศึกษาข้อมูลของเหรียญก่อนการลงทุนอย่างละเอียด',
        a_3: 'ศึกษา white paper ของเหรียญก่อนตัดสินใจลงทุน',
        a_4: 'ประเมินความเสี่ยงของตัวเองก่อนการลงทุน'
      },
      q_21: {
        q: 'มูลค่าตลาดของคริปโตเคอร์เรนซี (Market Capitalization) คำนวนได้อย่างไร',
        a_1: 'ราคาตลาด * ปริมาณฝากถอน',
        a_2: 'ราคาตลาด * ปริมาณของสินทรัพย์',
        a_3: 'ราคาตลาด * ความต้องการซื้อขาย',
        a_4: 'ถูกต้องทุกข้อ'
      }
    }
  },
  knowledge_test_correct_answer: {
    correct_answer: 'คำตอบที่ถูกต้อง'
  },
  summary_of_suit_test: {
    title: 'ผลทดสอบความเสี่ยงในการลงทุน',
    user_risk_point: 'ระดับคะแนนความเสี่ยงของคุณคือ <b>{suitabilityTestPoint}</b> จาก <b>45</b>',
    user_risk_level: {
      low: `แสดงว่าเป็นนักลงทุนประเภท<b>ความเสี่ยงต่ำ</b> กล่าวคือ ท่านต้องการผลตอบแทนจำนวนเล็กน้อยที่แน่นอน มากกว่าผลตอบแทนจำนวนมากที่ไม่แน่นอน<br><br>
      <b>เหมาะที่จะลงทุนโดยการฝากเงินธนาคาร หรือตราสารหนี้ความเสี่ยงต่ำ</b><br><br>
        <i>“การลงทุนในสินทรัพย์ดิจิทัลมีความผันผวนของตลาดและราคาภายในระยะเวลาอันรวดเร็ว ผู้ลงทุนควรศึกษาและทำความเข้าใจพื้นฐานการลงทุนด้านสินทรัพย์ดิจิทัลก่อนการลงทุน และควรติดต่อข่าวสารเกี่ยวกับสินทรัพย์ดิจิทัลอยู่เสมอระหว่างการลงทุน”</i>`,
      medium: `แสดงว่าเป็นนักลงทุนประเภท<b>ความเสี่ยงปานกลาง</b> กล่าวคือ ท่านสามารถรับความเสี่ยงได้บ้างเพื่อแลกกับผลตอบแทนที่เพิ่มขึ้น แต่ยังคงมุ่งเน้นปกป้องเงินลงทุนและหวังรายได้อย่างสม่ำเสมอจากการลงทุน<br><br>
      <b>เหมาะที่จะลงทุนโดยการซื้อตราสารหนี้หรือตราสารทุนความเสี่ยงต่ำ</b><br><br>
        <i>“การลงทุนในสินทรัพย์ดิจิทัลมีความผันผวนของตลาดและราคาภายในระยะเวลาอันรวดเร็ว ผู้ลงทุนควรศึกษาและทำความเข้าใจพื้นฐานการลงทุนด้านสินทรัพย์ดิจิทัลก่อนการลงทุน และควรติดต่อข่าวสารเกี่ยวกับสินทรัพย์ดิจิทัลอยู่เสมอระหว่างการลงทุน”</i>`,
      hight: `แสดงว่าเป็นนักลงทุนประเภท<b>ความเสี่ยงสูง</b> กล่าวคือ ท่านสามารถรับความเสี่ยงสูงจากการผันผวนของตลาดได้ โดยสามารถรับผลขาดทุนจำนวนมากเพื่อแลกกับโอกาสในการได้รับผลตอบแทนสูงหรือผลตอบแทนระยะยาว<br><br>
      <b>เหมาะที่จะลงทุนโดยการซื้อตราสารทุน ตราสารอนุพันธ์ หรือสินทรัพย์ดิจิทัลที่มีเสถียรภาพด้านราคา</b>`,
      very_hight: `แสดงว่าเป็นนักลงทุนประเภท<b>ความเสี่ยงสูงมาก</b>กล่าวคือ ท่านสามารถรับความเสี่ยงสูงมากจากการผันผวนของตลาดได้ โดยสามารถรับผลขาดทุนทั้งหมดเพื่อแลกกับโอกาสได้รับผลตอบแทนเป็นทวีคูณ<br><br>
      <b>เหมาะที่จะลงทุนโดยการซื้อสินทรัพย์ดิจิทัล</b>`
    },
    backward_btn: 'กลับหน้าหลัก',
    invite_knowledge_test: {
      title: 'ท่านต้องการทำแบบทดสอบความเสี่ยงในการลงทุนต่อเลยหรือไม่?',
      describe: 'เมื่อท่านได้รับการยืนยันตัวตน , ทำแบบทดสอบความเสี่ยงในการลงทุน และ ทำแบบทดสอบความรู้ เรียบร้อยแล้ว ท่านจะสามารถเทรดได้',
      text_btn: 'ทำแบบทดสอบความรู้'
    },
    rules_detail: `การลงทุนสินทรัพย์ดิจิทัลในระบบ decentralized เป็นการซื้อขายแลกเปลี่ยนสินทรัพย์ดิจิทัลโดยลูกค้าเป็นผู้เก็บรักษาสินทรัพย์ดิจิทัลไว้ด้วยตนเอง ลูกค้าจึงควรศึกษาและทำความเข้าใจวิธีการเก็บรักษาสินทรัพย์ดิจิทัลไว้ด้วยตนเองก่อนการลงทุนทุก
      ครั้ง นอกจากนี้ การโอนสินทรัพย์ดิจิทัลระหว่างกันเป็นการโอนกันตามความเป็นจริง จึงต้องใช้ระยะเวลาในการยืนยันธุรกรรม ซึ่งอาจทำให้อัตราแลกเปลี่ยนที่ลูกค้าได้รับเปลี่ยนแปลง ลูกค้าจึงควรศึกษาการกำหนดอัตราผันผวนและระยะเวลาการยืนยันธุรกรรมสินทรัพย์ดิจิทัลแต่ละประเภทก่อนการตัดสินใจลงทุนทุกครั้ง`
  },
  summart_of_knowledge_test: {
    title: 'ผลทดสอบความรู้',
    user_risk_point: 'ระดับคะแนนความรู้ของคุณคือ <b>{knowledgeTestPoint}</b> จาก <b>10</b>',
    describe: 'ท่านสามารถศึกษาหาความรู้เพิ่มเติมได้จากไฟล์ข้อมูลคำแนะนำการลงทุนต่อไปนี้',
    article_1: 'โลกแห่งสินทรัพย์ดิจิทัล (World of digital asset)',
    article_2: 'ระบบเศรษฐกิจสินทรัพย์ดิจิทัล (Ecosystem of digital asset)',
    article_3: 'พื้นฐานการลงทุนในสินทรัพย์ดิจิทัล (Basic of digital asset investment)',
    article_4: 'รูปแบบการให้บริการ (Service Form)',
    article_5: 'การแทรกแซงราคา (Market Manipulations)',
    article_6: ' ภาคผนวก (Appendix)',
    invite_suite_test: {
      title: 'ท่านต้องการทำแบบทดสอบความเสี่ยงต่อเลยหรือไม่?',
      describe: 'เมื่อท่านได้รับการยืนยันตัวตน, ทำแบบทดสอบความเสี่ยงในการลงทุน และ ทำแบบทดสอบความรู้ เรียบร้อยแล้ว ท่านจะสามารถเทรดได้',
      text_btn: 'ทำแบบทดสอบความเสี่ยงในการลงทุน'
    }
  },
  referral_program: {
    referral_program: 'โปรแกรมชวนเพื่อน',
    your_referral_link: 'ลิงก์ชวนเพื่อนของคุณ',
    qr_code: 'รหัสคิวอาร์ชวนเพื่อน :',
    download_qr: 'ดาวโหลดรหัสคิวอาร์',
    press_and_hold: 'แตะรูปรหัสคิวอาร์ค้างไว้เพื่อดาวโหลด',
    share_social: 'แชร์ไปโซเชียลเน็ตเวิร์ก :',
    url_referral: 'ลิงก์ชวนเพื่อน :',
    received: 'ได้รับแล้ว',
    invite_friends: 'ชวนเพื่อน',
    invited: 'รับเหรียญ {0} KUL (เชิญ {1} - {2} คน)',
    invited_up: 'รับเหรียญ {0} KUL (เชิญ {1} คนขึ้นไป)',
    level: 'ระดับ',
    earn_together: 'ได้รับเหรียญด้วยกัน',
    rules: 'กติกา',
    rules_detail: `1. เพื่อให้เพื่อนที่ถูกรับเชิญได้รับเหรียญ KULAP พวกเขาจะต้องลงทะเบียนโดยใช้ลิงก์อ้างอิงที่เกี่ยวข้อง (รหัสคิวอาร์หรือ ID ของผู้อ้างอิง)<br><br>
    2. ผู้เชิญจะได้รับเหรียญ KULAP ตามเงื่อนไขเมื่อบัญชีของผู้ได้รับเชิญเชื่อมต่อโซเชียลมีเดียของตนอย่างน้อยหนึ่งบัญชี<br><br>
    3. ไม่จำกัดจำนวนเพื่อนที่เชิญชวน<br><br>
    4. เราไม่อนุญาตให้เชิญตนเองผ่านการสมัครหลายบัญชี หากตรวจพบกิจกรรมดังกล่าว บัญชีผู้อ้างอิงและผู้ได้รับเชิญรวมทั้งเหรียญ KULAP ที่ได้รับจากการอ้างอิงทั้งหมดจะถูกยกเลิก/เรียกคืน<br><br>
    <b>มีผลตั้งแต่ 2019/09/09 0:00 AM (UTC)</b>`,
    detail: 'รายละเอียด',
    detail_explain: `<b>โปรแกรมชวนเพื่อนมีด้วยกัน 3 ระดับ</b><br><br>
    <b>ระดับ 1</b> - ทุกการชวนเพื่อนแต่ละครั้ง คนชวนจะได้รับเหรียญต่อการชวน<b>ครั้งละ 5 KULAP</b> และเมื่อชวนเพื่อน<b>มากกว่า 10 คน</b> จะได้รับการเพิ่มระดับ<br>
    <b>ระดับ 2</b> - ทุกการชวนเพื่อนแต่ละครั้ง คนชวนจะได้รับเหรียญต่อการชวน<b>ครั้งละ 10 KULAP</b> และเมื่อชวนเพื่อน<b>มากกว่า 10 คน</b> (รวมทั้งหมด 20 คน) จะได้รับการเพิ่มระดับ<br>
    <b>ระดับ 3</b> - ทุกการชวนเพื่อนแต่ละครั้ง คนชวนจะได้รับเหรียญต่อการชวน<b>ครั้งละ 15 KULAP</b><br><br>

    ตัวอย่าง ถ้าหากชวนเพื่อนทั้งหมด 35 คน คนชวนจะได้รับเหรียญ KULAP เท่าไหร่<br>
    สำหรับ 10 คนแรก จะได้รับเหรียญทั้งหมด 50 KULAP<br>
    และ 10 คนต่อมา จะได้รับเหรียญทั้งหมด 100 KULAP<br>
    และ 10 คนต่อมา จะได้รับเหรียญทั้งหมด 150 KULAP<br>
    และ 5 คนต่อมา จะได้รับเหรียญทั้งหมด 75 KULAP<br>
    สุดท้าย คนชวนจะได้รับเหรียญทั้งหมด 375 KULAP<br><br>

    ประกาศสำคัญ<br>
    ทางเราขอสงวนสิทธิ์ในการเปลี่ยนแปลงข้อกำหนดและเงื่อนไขของโปรแกรมชวนเพื่อนได้ตลอดเวลาโดยมิต้องแจ้งให้ทราบล่วงหน้า<br>`
  },
  terms_and_conditions: {
    template: termsAndConditionsTemplateTh
  },
  acknowledge_risk: {
    template: acknowledgeTemplateTh
  },
  two_factors: {
    verify_2fa: 'ตรวจสอบ 2FA',
    backup_key: 'สำรองคีย์',
    please_save_backup_key: 'กรุณาเก็บสำรองคีย์ไว้เพื่อกู้คืนการรับรองสิทธิ์ 2FA เมื่ออุปกรณ์ของคุณสูญหาย',
    enter_2fa_code: 'ใส่รหัส 2FA'
  },
  request_objective_of_trading: {
    since: 'เนื่องจากคุณได้ทำการซื้อ-ขายสินทรัพย์ดิจิตอลเกินกว่า 5,000,000 บาทขึ้นไป โปรดเลือกวัตถุประสงค์ในการทำธุรกรรม',
    if_user: 'หากคุณไม่กรอกแบบรายงานหรือยกเลิกคำสั่ง ทางเราจำเป็นต้องตรวจสอบการทำธุรกรรมของคุณ',
    fill_objective: 'ระบุวัตถุประสงค์ในการทำธุรกรรม',
    please_fill_objective: 'โปรดเลือกวัตถุประสงค์ในการทำธุรกรรม',
    please_fill: 'โปรดระบุ',
    fill_reason: 'ระบุวัตถุประสงค์ในการทำธุรกรรม',
    submit: 'ส่งข้อมูล'
  },
  trade_history: {
    title: 'ประวัติการเทรด',
    start_date: 'วันเริ่มต้น',
    end_data: 'วันสิ้นสุด',
    from_token: 'เหรียญต้นทาง',
    to_token: 'เหรียญปลายทาง',
    search: 'ค้นหา',
    download: 'ดาวน์โหลด',
    table_column_date: 'วันที่',
    table_column_from_token: 'เหรียญต้นทาง',
    table_column_to_token: 'เหรียญปลายทาง',
    table_column_value: 'มูลค่า',
    table_column_transactions: 'ธุรกรรม',
    empty_trade: 'รายการเทรดว่างเปล่า'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/th.js